/* ============== KERALUSH HAIR DIAGNOSTIC V2 (GLP-1) · VANILLA JS ============== */
/* Shopify port. Image URLs injected via window.KERALUSH_V2_IMGS (set by the
   section liquid). Mounts to #keralush-quiz-v2-root. */
(function () {
  'use strict';

  /* ============== DATA ============== */
  var _I = window.KERALUSH_V2_IMGS || {};

  var RIMG = {
    bundle_3:        _I.bundle_3        || 'quiz/img/bundle_3.webp?v=3',
    bundle_2:        _I.bundle_2        || 'quiz/img/bundle_2.webp?v=3',
    bundle_1:        _I.bundle_1        || 'quiz/img/bundle_1.webp?v=3',
    ig_keratin:      'https://rejuveen.com/cdn/shop/files/Ingredients_Keratin.jpg?v=1765775369&width=1080',
    ig_ashwagandha:  'https://rejuveen.com/cdn/shop/files/Ingredients_Ashwagandha.jpg?v=1765775433&width=1080',
    ig_zeropollution:'https://rejuveen.com/cdn/shop/files/Ingredients_Zeropollution.jpg?v=1765775495&width=1080',
    ig_biotin:       _I.ig_biotin       || 'quiz/img/ig_biotin_real.webp?v=3',
    ig_pantothenic:  _I.ig_pantothenic  || 'quiz/img/ig_pantothenic.webp?v=3',
    ig_zinc:         _I.ig_zinc         || 'quiz/img/ig_zinc.webp?v=3',
    ig_copper:       _I.ig_copper       || 'quiz/img/ig_copper.webp?v=3',
    ig_vitamin_c:    _I.ig_vitamin_c    || 'quiz/img/ig_vitamin_c.webp?v=3',
    ig_vitamin_e:    _I.ig_vitamin_e    || 'quiz/img/ig_vitamin_e.webp?v=3',
    ig_vitamins:     _I.ig_vitamin_c    || 'quiz/img/ig_vitamin_c.webp?v=3',
    bottle:          _I.bottle          || 'quiz/img/bottle.webp?v=3',
    megan:           _I.megan           || 'quiz/img/megan.webp?v=3',
    x_mark:          _I.x_mark          || 'quiz/img/x-mark.webp?v=3',
    life_chart:      'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/0f74bac2-aae6-455a-a2d1-36eb7de64341',
    life_anchor:     'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/18924535-49ff-4f89-81ae-4d5a86035c28',
    life_bottle_hair:'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/a0f74aae-abc8-432c-a848-c4d804910ec2',
    trig_1: 'https://rejuveen.com/cdn/shop/files/1_1b22c470-fab8-42fc-a969-7a708c339262_720x.png?v=1765773001',
    trig_4: 'https://rejuveen.com/cdn/shop/files/4_2acb95fb-98a0-419e-a2f4-59680724fd70_720x.png?v=1765773373',
    trig_5: 'https://rejuveen.com/cdn/shop/files/5_232a2ff7-cdf9-4c44-9e60-fadd29b0a805_720x.png?v=1765773473',
    ba_1: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/15c9e3df-ab5d-4307-a9e6-d3ff38800f7e',
    ba_2: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/373b9e60-8e9e-4d74-9614-29ce95d9bc1e',
    ba_3: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/f58b6c35-ff01-4d80-b4d7-34c720b73a06',
    ba_4: 'https://assets.replocdn.com/projects/4e13795c-0403-4afc-85ac-760dea33ba91/39de4c0e-f965-4906-9b02-573a8ad21e55',
    port_1: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/e772dc1d-792f-4bbd-ac4b-f72e42d3f9f1',
    port_2: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/96b703db-c77c-45ca-a68f-fec8f27ccc02',
    port_3: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/51a0d619-58b5-4566-8cda-45eef2c6afd1',
    port_4: 'https://assets.replocdn.com/projects/513afab3-e71a-4fc2-9c15-01cfc57893d5/1f32fe8f-da8f-44af-b000-9200ea9ea644',
    money_back: 'https://rejuveen.com/cdn/shop/files/money_back.png?v=1747364788&width=1080',
    intro_ba_hero:    _I.intro_ba_hero    || 'quiz/img/intro_ba_hero.webp?v=2',
    sleep_hair:       _I.sleep_hair       || 'quiz/img/sleep_hair.webp?v=2',
    ozempic_pen:      _I.ozempic_pen      || 'quiz/img/ozempic_pen.webp?v=2',
    shower_ba:        _I.shower_ba        || 'quiz/img/shower_ba.webp?v=2',
    weight_ba:        _I.weight_ba        || 'quiz/img/weight_ba.webp?v=2',
    cortisol_density: _I.cortisol_density || 'quiz/img/cortisol_density.webp?v=2',
  };

  var RIMG_DIMS = {
    intro_ba_hero:    { w: 720,  h: 472,  widths: [480, 720] },
    sleep_hair:       { w: 720,  h: 472,  widths: [480, 720] },
    ozempic_pen:      { w: 1024, h: 1024, widths: [480, 960] },
    shower_ba:        { w: 1350, h: 944,  widths: [480, 960] },
    weight_ba:        { w: 1080, h: 1080, widths: [480, 960] },
    cortisol_density: { w: 720,  h: 472,  widths: [480, 720] },
    ig_biotin_real:   { w: 240, h: 240, widths: [120, 240] },
    ig_copper:        { w: 240, h: 240, widths: [120, 240] },
    ig_pantothenic:   { w: 240, h: 240, widths: [120, 240] },
    ig_vitamin_c:     { w: 240, h: 240, widths: [120, 240] },
    ig_vitamin_e:     { w: 240, h: 240, widths: [120, 240] },
    ig_zinc:          { w: 240, h: 240, widths: [120, 240] },
    bundle_1:         { w: 240, h: 240, widths: [120, 240] },
    bundle_2:         { w: 240, h: 240, widths: [120, 240] },
    bundle_3:         { w: 240, h: 240, widths: [120, 240] },
    bottle:           { w: 640, h: 640, widths: [320, 640] },
    megan:            [200, 200],
    'x-mark':         [120, 120],
  };

  var _V = window.KERALUSH_V2_VARIANTS || {};
  var _v90 = _V.bundle90 || 46416449437858;
  var _v60 = _V.bundle60 || 46416449470626;
  var _v30 = _V.bundle30 || 46416449503394;
  var UPSELL = window.KERALUSH_V2_UPSELL || {};
  var BOGO = window.KERALUSH_V2_BOGO || {};

  var QUIZ_DATA = {
    questions: [
      {
        id: 'glp1', kind: 'radio', eyebrow: 'Question 01 · Your medication',
        title: "Which <em>weight-loss medication</em> are you on?",
        sub: "We tailor your protocol based on the specific cortisol and nutrient pathways your medication disrupts.",
        imageHero: RIMG.ozempic_pen,
        heroTransparent: true,
        options: [
          { v: 'ozempic',   label: 'Ozempic',   tag: 'semaglutide · 2.5× hair loss risk' },
          { v: 'wegovy',    label: 'Wegovy',    tag: 'semaglutide · 2.5× risk' },
          { v: 'mounjaro',  label: 'Mounjaro',  tag: 'tirzepatide · 1.7× risk' },
          { v: 'zepbound',  label: 'Zepbound',  tag: 'tirzepatide · 1.7× risk' },
          { v: 'other',     label: 'Other / compounded', tag: 'still at elevated risk' },
        ],
      },
      {
        id: 'duration', kind: 'radio', eyebrow: 'Question 02 · Timeline',
        title: "How long have you been <em>on the shot?</em>",
        sub: "Shedding typically peaks 3–6 months after you start. Knowing where you are matters.",
        options: [
          { v: 'lt3',    label: 'Less than 3 months',    tag: 'pre-shedding window' },
          { v: '3to6',   label: '3–6 months',            tag: 'peak risk phase' },
          { v: '6to12',  label: '6–12 months',           tag: 'chronic phase' },
          { v: 'gt12',   label: 'Over a year',           tag: 'long-term protocol' },
        ],
      },
      {
        id: 'shedding', kind: 'severity', eyebrow: 'Question 03 · Severity',
        title: "How much hair comes out <em>in the shower</em>?",
        sub: "Be honest. 50–100 hairs a day is normal. We're looking for clumps.",
        imageHero: RIMG.shower_ba,
        scale: [
          { v: 1, label: 'Normal' },
          { v: 2, label: 'A bit more' },
          { v: 3, label: 'Noticeable' },
          { v: 4, label: 'Handfuls' },
          { v: 5, label: 'Clumps' },
        ],
      },
      {
        id: 'pillow', kind: 'radio', eyebrow: 'Question 04 · Visible signs',
        title: "What do you see <em>on your pillow</em> every morning?",
        options: [
          { v: 'a', label: "Almost nothing", tag: '' },
          { v: 'b', label: "A few strands", tag: '' },
          { v: 'c', label: "Enough that I notice daily", tag: '' },
          { v: 'd', label: "I stopped looking", tag: 'we hear you' },
        ],
      },
      {
        id: 'part', kind: 'radio', eyebrow: 'Question 05 · Thinning pattern',
        title: "Has your <em>part</em> gotten wider?",
        sub: "Or ponytail thinner, or temples patchier... anywhere you've noticed loss of density.",
        imageHero: RIMG.ba_3,
        options: [
          { v: 'no',      label: "No, density feels the same", tag: '' },
          { v: 'slight',  label: "Slightly... could be in my head", tag: '' },
          { v: 'yes',     label: "Yes, clearly wider", tag: '' },
          { v: 'alot',    label: "Dramatically... I can see scalp", tag: 'urgent' },
        ],
      },
      {
        id: 'age', kind: 'pills', eyebrow: 'Question 06 · Life stage',
        title: "What's your <em>age range?</em>",
        sub: "Estrogen, cortisol, and follicle-anchor proteins all shift with age.",
        options: [
          { v: '25-34', big: '25–34', small: 'pre-peri' },
          { v: '35-44', big: '35–44', small: 'perimeno' },
          { v: '45-54', big: '45–54', small: 'meno' },
          { v: '55+',   big: '55+',   small: 'post-meno' },
        ],
      },
      {
        id: 'weight', kind: 'radio', eyebrow: 'Question 07 · Your progress',
        title: "How much weight have you <em>lost so far?</em>",
        sub: "Rapid weight loss releases stored toxins into your bloodstream. We account for that.",
        imageHero: RIMG.weight_ba,
        options: [
          { v: '<15',   label: 'Under 15 lbs',   tag: 'mild toxin release' },
          { v: '15-30', label: '15–30 lbs',      tag: 'moderate release' },
          { v: '30-50', label: '30–50 lbs',      tag: 'significant release' },
          { v: '50+',   label: 'Over 50 lbs',    tag: 'maximum toxin load' },
        ],
      },
      {
        id: 'stress', kind: 'radio', eyebrow: 'Question 08 · Cortisol load',
        title: "How's your <em>stress</em> right now?",
        sub: "Cortisol blocks GAS6... the molecule that tells follicles to stay in growth mode.",
        imageHero: RIMG.cortisol_density,
        options: [
          { v: 1, label: 'Manageable',       tag: 'baseline' },
          { v: 2, label: 'Moderate',         tag: '' },
          { v: 3, label: 'High',             tag: '' },
          { v: 4, label: 'Through the roof', tag: 'cortisol surge' },
        ],
      },
      {
        id: 'sleep', kind: 'radio', eyebrow: 'Question 09 · Recovery',
        title: "How's your <em>sleep?</em>",
        sub: "Follicles rebuild keratin during deep sleep. Poor sleep = weaker hair.",
        beforeAfter: true,
        options: [
          { v: 'good',   label: '7+ hrs, sleeping deeply', tag: '' },
          { v: 'ok',     label: '6–7 hrs, decent', tag: '' },
          { v: 'broken', label: 'I wake up during the night', tag: '' },
          { v: 'bad',    label: 'Less than 6 hrs / exhausted', tag: '' },
        ],
      },
      {
        id: 'tried', kind: 'chips', eyebrow: "Question 10 · What you've tried",
        title: "What have you <em>already tried?</em>",
        sub: "Select any. Most single-ingredient solutions only address 1 of the 5 triggers.",
        options: [
          { v: 'biotin',     label: 'Biotin' },
          { v: 'collagen',   label: 'Collagen' },
          { v: 'minoxidil',  label: 'Minoxidil (topical)' },
          { v: 'supplement', label: 'A hair growth supplement' },
          { v: 'shampoo',    label: 'Thickening shampoos' },
          { v: 'rosemary',   label: 'Rosemary oil' },
          { v: 'topical',    label: 'Scalp serums' },
          { v: 'nothing',    label: "Nothing yet" },
        ],
      },
      {
        id: 'goal', kind: 'radio', eyebrow: 'Question 11 · Your goal',
        title: "What's your <em>#1 goal?</em>",
        sub: "We'll personalize your 90-day protocol around this.",
        imageHero: RIMG.ba_2,
        options: [
          { v: 'stop-shed', label: "Stop the shedding... now",                          tag: 'urgent protocol' },
          { v: 'regrow',    label: "Regrow what I've lost",                             tag: '90-day track' },
          { v: 'thicken',   label: "Thicker, fuller hair",                              tag: 'density track' },
          { v: 'keep-shot', label: "Keep my GLP-1 results without losing my hair",      tag: 'protect + restore' },
        ],
      },
    ],

    dropListLibrary: {
      'Biotin':
        "Surface-level cofactor support. Doesn't restore IGF-1 signaling, doesn't lower cortisol, doesn't rebuild anchor proteins. A 2017 systematic review found zero studies showing biotin helps non-deficient women regrow hair.",
      'Collagen':
        "Doesn't survive digestion in the form follicles use. Designed to support skin and joints, not the keratin structure of the hair shaft.",
      'Minoxidil (topical)':
        "Boosts blood flow to follicles. Useful if circulation is the problem. It isn't on a GLP-1... your follicles aren't blood-starved, they're signal-starved or anchor-stripped.",
      'A hair growth supplement':
        "Most are formulated for hormonal or genetic hair loss. They don't address either GLP-1 trigger. If your supplement isn't built around Shoden® and keraGEN-iV at clinical dose, it isn't built for this.",
      'Thickening shampoos':
        "Coats the strands you already have. Has zero effect on follicle biology underneath.",
      'Rosemary oil':
        "Mild circulation effect at the scalp. Doesn't restore anchor proteins or signaling pathways. Same category as minoxidil... right tool, wrong problem.",
      'Scalp serums':
        "Topical actives don't reach the dermal papilla where the actual signaling happens. Anything that needs to lower cortisol or restore GAS6 has to be systemic.",
    },

    education: {
      stat1: {
        badge: 'RESEARCH INSERT',
        label: 'The risk is real.',
        num: 2.5, suffix: '×',
        cap: "higher risk of significant hair loss with semaglutide vs. non-users.",
        source: "Peer-reviewed cohort analysis, 1,922 weight-loss medication users (2024). Tirzepatide carries a 1.7× elevated risk.",
        image: RIMG.life_chart,
      },
      stat2: {
        badge: 'THE PATHWAY',
        label: 'Why "the shot" steals hair.',
        image: RIMG.life_bottle_hair,
        triggers: [
          { n: 1, name: 'Toxin Tsunami',       txt: "Rapid fat loss dumps stored toxins into your bloodstream... oxidative chaos for follicles.", img: RIMG.trig_1 },
          { n: 2, name: 'Nutrient Starvation', txt: "Reduced appetite = your follicles, nails, skin starve first. Iron, zinc, protein, biotin diverted away.", img: RIMG.trig_4 },
          { n: 3, name: 'Cortisol Surge',      txt: "Rapid body change = stress. Cortisol blocks GAS6 signaling. Follicles get stuck in resting phase.", img: RIMG.trig_1 },
          { n: 4, name: 'Muscle Inflammation', txt: "Up to 40% of GLP-1 weight loss can come from muscle, not fat. The lost lean mass releases inflammatory signals that attack hair anchor proteins (COL17A1).", img: RIMG.life_anchor },
          { n: 5, name: 'Anchor Breakdown',    txt: "The microscopic roots holding each strand weaken. Healthy-looking hair just… slides out.", img: RIMG.trig_5 },
        ],
      },
      stat3: {
        badge: 'CLINICAL EVIDENCE',
        num: 43.1, suffix: '%',
        cap: "reduction in hair loss in 60 days with keraGEN-IV® keratin peptides.",
        source: "Randomized, double-blind, placebo-controlled clinical trial. 65 women. Peer-reviewed.",
        extra: "17.6% stronger strands · Measured via birefringence analysis",
        image: RIMG.ig_keratin,
      },
    },
  };

  /* Debug logging gate. Off in production by default. Turn on with either
     ?debug=1 in the URL or localStorage.setItem('keralush_debug','1'). */
  var DEBUG = (function () {
    try {
      if (typeof window === 'undefined') return false;
      if (/[?&]debug=1\b/.test(window.location.search)) return true;
      if (window.localStorage && window.localStorage.getItem('keralush_debug') === '1') return true;
    } catch (e) {}
    return false;
  })();
  var dbg = function () { if (DEBUG && typeof console !== 'undefined') console.debug.apply(console, arguments); };

  /* ---------- small DOM helpers ---------- */
  function h(html) {
    var t = document.createElement('template');
    t.innerHTML = String(html).trim();
    return t.content.firstElementChild;
  }
  function attr(v) {
    return String(v == null ? '' : v).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  /* ============== HeroPic ==============
     Renders a <picture> with WebP source + PNG/JPG fallback for local images,
     and a plain <img> for everything else (external CDN urls). Auto-fills
     width/height from REJ_HERO_DIMS so the browser can reserve layout space and
     avoid CLS. When the dims entry includes a `widths` list, also emits a
     responsive srcset pointing at the corresponding `<name>-Nw.{webp,png}`
     variants in img/. Returns an HTML string. */
  var DEFAULT_HERO_SIZES = '(max-width: 480px) 100vw, 440px';
  function buildSrcSet(basePath, name, naturalW, widths, ext, query) {
    return widths.map(function (w) {
      var file = w === naturalW ? (basePath + name + '.' + ext + query) : (basePath + name + '-' + w + 'w.' + ext + query);
      return file + ' ' + w + 'w';
    }).join(', ');
  }
  function heroPic(opts) {
    opts = opts || {};
    var src = opts.src;
    if (!src) return '';
    var loading = opts.loading || 'lazy';
    var decoding = opts.decoding || 'async';
    var fallbackExt = opts.fallback || 'png';
    var localMatch = src.match(/^(.*\/img\/)([a-z0-9_-]+)\.webp(\?[^#]*)?$/i);
    var isLocalWebp = !!localMatch;
    var w = opts.width, hgt = opts.height;
    var webpSrcSet = null, pngSrcSet = null;
    var pngSrc = isLocalWebp ? src.replace(/\.webp(\?|$)/, '.' + fallbackExt + '$1') : src;
    var imgSizes = opts.sizes;

    if (isLocalWebp) {
      var basePath = localMatch[1], name = localMatch[2], rawQuery = localMatch[3];
      var query = rawQuery || '';
      var dims = RIMG_DIMS[name];
      if (dims) {
        if (Array.isArray(dims)) {
          w = w || dims[0]; hgt = hgt || dims[1];
        } else {
          w = w || dims.w; hgt = hgt || dims.h;
          if (dims.widths && dims.widths.length > 1) {
            webpSrcSet = buildSrcSet(basePath, name, dims.w, dims.widths, 'webp', query);
            pngSrcSet = buildSrcSet(basePath, name, dims.w, dims.widths, fallbackExt, query);
            if (!imgSizes) imgSizes = DEFAULT_HERO_SIZES;
          }
        }
      }
    }

    var imgAttrs = '';
    imgAttrs += ' src="' + attr(pngSrc) + '"';
    if (pngSrcSet) imgAttrs += ' srcset="' + attr(pngSrcSet) + '"';
    if (pngSrcSet && imgSizes) imgAttrs += ' sizes="' + attr(imgSizes) + '"';
    imgAttrs += ' alt="' + attr(opts.alt || '') + '"';
    imgAttrs += ' loading="' + attr(loading) + '"';
    imgAttrs += ' decoding="' + attr(decoding) + '"';
    if (opts.fetchpriority) imgAttrs += ' fetchpriority="' + attr(opts.fetchpriority) + '"';
    if (w != null) imgAttrs += ' width="' + attr(w) + '"';
    if (hgt != null) imgAttrs += ' height="' + attr(hgt) + '"';
    if (opts.style) imgAttrs += ' style="' + attr(opts.style) + '"';
    if (opts.className) imgAttrs += ' class="' + attr(opts.className) + '"';
    var imgEl = '<img' + imgAttrs + '>';

    if (!isLocalWebp) return imgEl;
    var sourceSrcSet = webpSrcSet || src;
    var sourceSizes = (webpSrcSet && imgSizes) ? (' sizes="' + attr(imgSizes) + '"') : '';
    return '<picture><source srcset="' + attr(sourceSrcSet) + '"' + sourceSizes + ' type="image/webp">' + imgEl + '</picture>';
  }

  /* ============== TRACKING HELPER ============== */
  var STANDARD_PIXEL_EVENTS = { Lead: 1, AddToCart: 1, InitiateCheckout: 1 };
  var GA4_EVENT_MAP = {
    QuizStart: 'quiz_start',
    QuizComplete: 'quiz_complete',
    Lead: 'generate_lead',
    AddToCart: 'add_to_cart',
    InitiateCheckout: 'begin_checkout'
  };
  function track(name, params) {
    params = params || {};
    try {
      if (typeof window.fbq === 'function') {
        if (STANDARD_PIXEL_EVENTS[name]) window.fbq('track', name, params);
        else window.fbq('trackCustom', name, params);
      }
      if (typeof window.gtag === 'function') {
        window.gtag('event', GA4_EVENT_MAP[name] || name, params);
      }
      dbg('[track]', name, params);
    } catch (err) {
      if (typeof console !== 'undefined') console.warn('[track] failed', name, err);
    }
  }
  function klaviyoIdentify(props) {
    try {
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', props]);
      dbg('[klaviyo identify]', props);
    } catch (err) {
      if (typeof console !== 'undefined') console.warn('[klaviyo identify] failed', err);
    }
  }

  /* ============== OFFER PACKAGES ==============
     variantId = Shopify product variant numeric ID (used by /cart/add.js).
     url       = legacy cart-permalink fallback for the static dev preview. */
  var PACKAGES = [
    { k: '90', months: '90-Day Supply', bottles: 3, per: '$2.30', total: 207, strike: 297, save: 30, coupon: 10, finalTotal: 197, finalPer: '$2.19', totalSaved: 100, badge: 'BEST VALUE', bundle: RIMG.bundle_3, variantId: _v90, url: 'https://rejuveen.com/cart/' + _v90 + ':1' },
    { k: '60', months: '60-Day Supply', bottles: 2, per: '$2.47', total: 148, strike: 198, save: 25, coupon: 10, finalTotal: 138, finalPer: '$2.30', totalSaved: 60, badge: 'POPULAR', bundle: RIMG.bundle_2, variantId: _v60, url: 'https://rejuveen.com/cart/' + _v60 + ':1' },
    { k: '30', months: '30-Day Supply', bottles: 1, per: '$2.63', total: 79, strike: 99, save: 20, coupon: 0, finalTotal: 79, finalPer: '$2.63', totalSaved: 20, badge: null, bundle: RIMG.bundle_1, variantId: _v30, url: 'https://rejuveen.com/cart/' + _v30 + ':1' }
  ];

  // Session-scoped Lead dedupe — one Lead event per browser tab.
  var LEAD_FIRED_KEY = 'kl_lead_fired';
  function hasLeadFired() { try { return sessionStorage.getItem(LEAD_FIRED_KEY) === '1'; } catch (e) { return false; } }
  function markLeadFired() { try { sessionStorage.setItem(LEAD_FIRED_KEY, '1'); } catch (e) {} }

  /* ============== SAFE STORAGE ============== */
  var safeLS = (function () {
    try {
      var t = '__klt__'; localStorage.setItem(t, '1'); localStorage.removeItem(t);
      return {
        get: function (k) { return localStorage.getItem(k); },
        set: function (k, v) { localStorage.setItem(k, v); },
        remove: function (k) { localStorage.removeItem(k); }
      };
    } catch (e) {
      var mem = {};
      return {
        get: function (k) { return (k in mem) ? mem[k] : null; },
        set: function (k, v) { mem[k] = String(v); },
        remove: function (k) { delete mem[k]; }
      };
    }
  })();

  /* ============== STEPS ============== */
  var STEPS = [
    { type: 'intro' },
    { type: 'q', idx: 0 },
    { type: 'q', idx: 1 },
    { type: 'edu1' },
    { type: 'q', idx: 2 },
    { type: 'q', idx: 3 },
    { type: 'q', idx: 4 },
    { type: 'edu2' },
    { type: 'q', idx: 5 },
    { type: 'q', idx: 6 },
    { type: 'q', idx: 7 },
    { type: 'edu3' },
    { type: 'q', idx: 8 },
    { type: 'q', idx: 9 },
    { type: 'q', idx: 10 },
    { type: 'analyze' },
    { type: 'results' }
  ];

  /* ============== APP STATE ============== */
  var state = {
    step: (function () {
      var s = parseInt(safeLS.get('kl_step') || '0', 10);
      return isNaN(s) ? 0 : Math.min(s, STEPS.length - 1);
    })(),
    answers: (function () {
      try { return JSON.parse(safeLS.get('kl_answers') || '{}'); } catch (e) { return {}; }
    })()
  };

  function persistStep() { safeLS.set('kl_step', String(state.step)); }
  function persistAnswers() { safeLS.set('kl_answers', JSON.stringify(state.answers)); }

  // Active timers/listeners that must be cleaned when the screen changes.
  var cleanupFns = [];
  function runCleanup() {
    while (cleanupFns.length) {
      var fn = cleanupFns.pop();
      try { fn(); } catch (e) {}
    }
  }

  function resetScroll() {
    var frame = document.querySelector('.phone-frame');
    if (frame) frame.scrollTop = 0;
    var body = document.querySelector('.quiz-body');
    if (body) body.scrollTop = 0;
    window.scrollTo(0, 0);
  }

  function goNext() { navigate(Math.min(state.step + 1, STEPS.length - 1)); }
  function goBack() { navigate(Math.max(state.step - 1, 0)); }
  function navigate(n) { state.step = n; persistStep(); renderApp(); resetScroll(); }
  function restart() { state.answers = {}; persistAnswers(); state.step = 0; persistStep(); renderApp(); resetScroll(); }
  function setAnswer(id, v) { state.answers[id] = v; persistAnswers(); }
  function startQuiz() { track('QuizStart', { content_name: 'hair_diagnostic_quiz' }); goNext(); }

  function frameIsScrollable(frame) {
    if (!frame) return false;
    return frame.scrollHeight > frame.clientHeight + 1;
  }

  /* Match the original quiz scroll behavior: mobile results scroll inside
     `.phone-frame`, while desktop/tablet layouts scroll the page itself. */
  function scrollToId(id, offset) {
    var elTarget = document.getElementById(id);
    if (!elTarget) return;
    if (offset == null) offset = id === 'offer-anchor' ? 12 : 60;

    var frame = document.querySelector('#keralush-quiz-root .phone-frame');
    if (frameIsScrollable(frame)) {
      var target = elTarget.getBoundingClientRect().top - frame.getBoundingClientRect().top + frame.scrollTop - offset;
      try {
        frame.scrollTo({ top: target, behavior: 'smooth' });
      } catch (e) {
        frame.scrollTop = target;
      }
      return;
    }

    var rect = elTarget.getBoundingClientRect();
    var pageY = rect.top + (window.pageYOffset || document.documentElement.scrollTop || 0) - offset;
    try {
      window.scrollTo({ top: pageY, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, pageY);
    }
  }

  /* ============== INTRO ============== */
  function introHTML() {
    return '' +
    '<div class="quiz-shell intro-shell">' +
      '<div class="quiz-body">' +
        '<div class="hero">' +
          '<div style="position:relative;z-index:2">' +
            '<div class="hero-pre"><span class="dot">●</span> FOR WOMEN ON OZEMPIC · WEGOVY · MOUNJARO · ZEPBOUND</div>' +
            '<h1 class="hero-title hero-title-v2">Stop the shed.<br><em>Without quitting the shot.</em></h1>' +
            '<div class="hero-poster hero-poster-v2">' +
              heroPic({ src: RIMG.intro_ba_hero, alt: 'Before and after... hair restored after GLP-1 shedding', loading: 'eager', fetchpriority: 'high', decoding: 'sync' }) +
              '<span class="corner-tag corner-tag-l">WEEK 1</span>' +
              '<span class="corner-tag corner-tag-r">WEEK 18</span>' +
              '<div class="overlay overlay-3line">' +
                '<div class="cap-1">"My hair came back."</div>' +
                '<div class="cap-2">(I\'m still down 52 lbs.)</div>' +
                '<div class="cap-3">DANA R. · 9 MONTHS ON WEGOVY</div>' +
              '</div>' +
            '</div>' +
            '<div class="unified-card">' +
              '<p class="uc-prop">In 60 seconds, find out which of the <strong class="hl-orange">2 GLP-1 hair-loss pathways</strong> is hitting your follicles... and the protocol to address it without going off your shot.</p>' +
              '<p class="uc-prop-italic">Built around your medication, your dose, and your shedding pattern.</p>' +
              '<div class="quiz-preview">' +
                '<div class="qp-label">Q1 OF 11 · ~60 SECONDS</div>' +
                '<div class="qp-bar"><div class="qp-fill"></div></div>' +
                '<div class="qp-question">Which GLP-1 are you on?</div>' +
              '</div>' +
              '<button class="btn-primary uc-cta" data-action="start">REVEAL MY HAIR-LOSS TRIGGERS <span class="arrow">→</span></button>' +
              '<div class="uc-trust">Private · No email to see your results · Formulated with trichologists</div>' +
            '</div>' +
            '<div class="cred-strip">' +
              '<div class="cred-col"><div class="cred-num">43.1%</div><div class="cred-lbl">Less hair fall in 60 days</div><div class="cred-src">Clinical, keraGEN-iV™</div></div>' +
              '<div class="cred-col"><div class="cred-num">66%</div><div class="cred-lbl">Cortisol reduction in 60 days</div><div class="cred-src">Clinical, Shoden® Ashwagandha</div></div>' +
              '<div class="cred-col"><div class="cred-num">Zero</div><div class="cred-lbl">Known GLP-1 interactions</div><div class="cred-src">Reviewed by endocrine RNs</div></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<button class="sticky-cta" data-action="start" hidden>START THE 90-SECOND QUIZ <span class="arrow">→</span></button>' +
    '</div>';
  }
  function wireIntro(rootEl) {
    rootEl.querySelectorAll('[data-action="start"]').forEach(function (b) {
      b.addEventListener('click', startQuiz);
    });
    var sticky = rootEl.querySelector('.sticky-cta');
    var onScroll = function () {
      if (window.scrollY > 120) sticky.removeAttribute('hidden');
      else sticky.setAttribute('hidden', '');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    cleanupFns.push(function () { window.removeEventListener('scroll', onScroll); });
  }

  /* ============== QUESTION ============== */
  function questionHTML(q, idx, total) {
    var value = state.answers[q.id];
    var progress = (idx + 1) / total * 100;
    var canContinue = q.kind === 'chips' ? (value && value.length > 0) : (value !== undefined && value !== null);
    var hasHero = (q.imageHero && !q.heroTransparent) || q.beforeAfter;

    var body = '';
    if (q.imageHero) {
      body += '<div class="q-hero-img' + (q.heroTransparent ? ' is-floating' : '') + '">' +
        heroPic({ src: q.imageHero, alt: '', style: 'object-fit:contain' }) + '</div>';
    }
    if (q.beforeAfter) {
      body += '<div class="q-sleep-hero">' +
        heroPic({ src: RIMG.sleep_hair, alt: 'Hair shed on pillow after sleep' }) +
        '<div class="q-sleep-cap">Hair on the pillow · every morning</div></div>';
    }
    body += '<h1 class="q-title">' + q.title + '</h1>';
    if (q.sub) body += '<p class="q-sub">' + q.sub + '</p>';

    if (q.kind === 'radio') {
      body += '<div class="options">';
      q.options.forEach(function (o, i) {
        var sel = value === o.v;
        body += '<button class="option' + (sel ? ' selected' : '') + '" data-v="' + attr(o.v) + '" style="animation-delay:' + (i * 60) + 'ms">' +
          '<span class="label"><div>' + o.label + '</div>' + (o.tag ? '<div class="tag">' + o.tag + '</div>' : '') + '</span>' +
          '<span class="check">' + (sel ? '✓' : '') + '</span></button>';
      });
      body += '</div>';
    } else if (q.kind === 'severity') {
      body += '<div class="severity">';
      q.scale.forEach(function (s) {
        var sel = value === s.v;
        body += '<button class="severity-cell' + (sel ? ' selected' : '') + '" data-v="' + attr(s.v) + '">' +
          '<span class="sev-num">' + s.v + '</span><span class="sev-label">' + s.label + '</span></button>';
      });
      body += '</div>';
      body += '<div style="display:flex;justify-content:space-between;font-family:var(--mono);font-size:10px;color:var(--ink-3);margin-top:12px;letter-spacing:.14em;text-transform:uppercase"><span>Normal</span><span>Severe</span></div>';
    } else if (q.kind === 'pills') {
      body += '<div class="pills">';
      q.options.forEach(function (o) {
        var sel = value === o.v;
        body += '<button class="pill' + (sel ? ' selected' : '') + '" data-v="' + attr(o.v) + '">' +
          '<span class="big">' + o.big + '</span><span class="small">' + o.small + '</span></button>';
      });
      body += '</div>';
    } else if (q.kind === 'chips') {
      body += '<div class="chips">';
      var arr = value || [];
      q.options.forEach(function (o) {
        var on = arr.indexOf(o.v) !== -1;
        body += '<button class="chip' + (on ? ' selected' : '') + '" data-v="' + attr(o.v) + '">' +
          o.label + (on ? ' <span class="x">✓</span>' : '') + '</button>';
      });
      body += '</div>';
    }

    return '' +
    '<div class="quiz-shell">' +
      '<div class="top-bar">' +
        '<button class="back-btn" data-action="back">← Back</button>' +
        '<div class="brand"><em>rejuveen</em></div>' +
        '<button class="skip-btn" data-action="next">Skip</button>' +
      '</div>' +
      '<div class="progress-wrap">' +
        '<div class="progress-meta"><span>' + q.eyebrow + '</span><span>' + (idx + 1) + ' / ' + total + '</span></div>' +
        '<div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>' +
      '</div>' +
      '<div class="quiz-body">' +
        '<div class="screen' + (hasHero ? ' has-hero' : '') + '" data-screen-label="Q' + String(idx + 1).padStart(2, '0') + '">' +
          body +
        '</div>' +
      '</div>' +
      (q.kind === 'chips' ? (
        '<div class="quiz-footer">' +
          (!canContinue ? '<div class="footer-hint">Select at least one option</div>' : '') +
          '<button class="btn-primary" data-action="next"' + (canContinue ? '' : ' disabled') + '>Continue <span class="arrow">→</span></button>' +
        '</div>'
      ) : '') +
    '</div>';
  }

  function wireQuestion(rootEl, q, idx, total) {
    rootEl.querySelectorAll('[data-action="back"]').forEach(function (b) { b.addEventListener('click', goBack); });
    rootEl.querySelectorAll('[data-action="next"]').forEach(function (b) {
      b.addEventListener('click', function () { if (!b.disabled) goNext(); });
    });

    // Schedule the auto-advance and register it for cleanup so a rapid second
    // tap (which re-renders and runs runCleanup) cannot fire two navigations.
    function scheduleAdvance(delay) {
      var id = setTimeout(goNext, delay);
      cleanupFns.push(function () { clearTimeout(id); });
    }

    if (q.kind === 'radio') {
      var allOptions = rootEl.querySelectorAll('.option');
      allOptions.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var raw = btn.getAttribute('data-v');
          var opt = q.options.filter(function (o) { return String(o.v) === raw; })[0];
          setAnswer(q.id, opt ? opt.v : raw);
          allOptions.forEach(function (b) {
            b.classList.remove('selected');
            var chk = b.querySelector('.check');
            if (chk) chk.textContent = '';
          });
          btn.classList.add('selected');
          var chk = btn.querySelector('.check');
          if (chk) chk.textContent = '✓';
          scheduleAdvance(320);
        });
      });
    } else if (q.kind === 'severity') {
      var allCells = rootEl.querySelectorAll('.severity-cell');
      allCells.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var raw = btn.getAttribute('data-v');
          var s = q.scale.filter(function (o) { return String(o.v) === raw; })[0];
          setAnswer(q.id, s ? s.v : raw);
          allCells.forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          scheduleAdvance(360);
        });
      });
    } else if (q.kind === 'pills') {
      var allPills = rootEl.querySelectorAll('.pill');
      allPills.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var raw = btn.getAttribute('data-v');
          var opt = q.options.filter(function (o) { return String(o.v) === raw; })[0];
          setAnswer(q.id, opt ? opt.v : raw);
          allPills.forEach(function (b) { b.classList.remove('selected'); });
          btn.classList.add('selected');
          scheduleAdvance(320);
        });
      });
    } else if (q.kind === 'chips') {
      var continueBtn = rootEl.querySelector('.quiz-footer .btn-primary');
      var hintEl = rootEl.querySelector('.footer-hint');
      rootEl.querySelectorAll('.chip').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var v = btn.getAttribute('data-v');
          var arr = Array.isArray(state.answers[q.id]) ? state.answers[q.id] : [];
          var on = arr.indexOf(v) !== -1;
          var next;
          if (v === 'nothing') {
            next = on ? [] : ['nothing'];
          } else {
            next = on
              ? arr.filter(function (x) { return x !== v; })
              : arr.filter(function (x) { return x !== 'nothing'; }).concat([v]);
          }
          setAnswer(q.id, next);
          // update chip UI in-place
          rootEl.querySelectorAll('.chip').forEach(function (c) {
            var cv = c.getAttribute('data-v');
            var active = next.indexOf(cv) !== -1;
            c.classList.toggle('selected', active);
            var xEl = c.querySelector('.x');
            if (active && !xEl) {
              c.insertAdjacentHTML('beforeend', ' <span class="x">✓</span>');
            } else if (!active && xEl) {
              xEl.remove();
            }
          });
          // update footer button state in-place
          var hasSelection = next.length > 0;
          if (continueBtn) continueBtn.disabled = !hasSelection;
          if (hintEl) hintEl.style.display = hasSelection ? 'none' : '';
        });
      });
    }
  }

  /* ============== EDUCATION · STAT ============== */
  function eduStatHTML(data, idx, total) {
    var progress = (idx + 0.5) / total * 100;
    return '' +
    '<div class="quiz-shell">' +
      '<div class="top-bar">' +
        '<button class="back-btn" data-action="back">← Back</button>' +
        '<div class="brand"><em>rejuveen</em></div>' +
        '<span style="width:30px"></span>' +
      '</div>' +
      '<div class="progress-wrap">' +
        '<div class="progress-meta"><span>Insight</span><span>...</span></div>' +
        '<div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>' +
      '</div>' +
      '<div class="quiz-body">' +
        '<div class="edu">' +
          '<div class="edu-badge"><span class="dot"></span>' + data.badge + '</div>' +
          '<h1 class="q-title" style="font-size:26px">' + (data.label || '') + '</h1>' +
          (data.image ? '<div class="edu-hero-img"><img src="' + attr(data.image) + '" alt="" style="object-fit:contain"></div>' : '') +
          '<div class="stat-hero"><span class="stat-num">0</span><span class="pct">' + data.suffix + '</span></div>' +
          '<div class="stat-cap">' + data.cap + '</div>' +
          '<div class="stat-source">' + data.source + '</div>' +
          (data.extra ? '<div class="stat-source" style="border-top:none;padding-top:6px;color:var(--orange);font-weight:600">' + data.extra + '</div>' : '') +
        '</div>' +
      '</div>' +
      '<div class="quiz-footer">' +
        '<button class="btn-primary" data-action="next">I want to know more <span class="arrow">→</span></button>' +
      '</div>' +
    '</div>';
  }
  function wireEduStat(rootEl, data) {
    rootEl.querySelector('[data-action="back"]').addEventListener('click', goBack);
    rootEl.querySelector('[data-action="next"]').addEventListener('click', goNext);
    // count-up animation (easeOutCubic), 1600ms
    var numEl = rootEl.querySelector('.stat-num');
    var target = data.num, duration = 1600, t0 = null, raf;
    function fmt(v) { return v.toFixed(1).replace('.0', ''); }
    function tick(t) {
      if (!t0) t0 = t;
      var p = Math.min(1, (t - t0) / duration);
      numEl.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
      if (p < 1) raf = requestAnimationFrame(tick);
      else numEl.textContent = fmt(target);
    }
    raf = requestAnimationFrame(tick);
    cleanupFns.push(function () { cancelAnimationFrame(raf); });
  }

  /* ============== EDUCATION · TRIGGERS ============== */
  function eduTriggersHTML(data, idx, total) {
    var progress = (idx + 0.5) / total * 100;
    var rows = '';
    data.triggers.forEach(function (t) {
      rows += '<div class="trigger-row" data-n="' + attr(t.n) + '" style="opacity:0;transform:translateX(-20px)">' +
        '<div class="trigger-img"><img src="' + attr(t.img) + '" alt="' + attr(t.name) + '"><span class="trigger-num">' + t.n + '</span></div>' +
        '<div class="trigger-meta"><div class="t-name">' + t.name + '</div><div class="t-txt">' + t.txt + '</div></div>' +
      '</div>';
    });
    return '' +
    '<div class="quiz-shell">' +
      '<div class="top-bar">' +
        '<button class="back-btn" data-action="back">← Back</button>' +
        '<div class="brand"><em>rejuveen</em></div>' +
        '<span style="width:30px"></span>' +
      '</div>' +
      '<div class="progress-wrap">' +
        '<div class="progress-meta"><span>The Pathway</span><span>...</span></div>' +
        '<div class="progress-bar"><div class="progress-fill" style="width:' + progress + '%"></div></div>' +
      '</div>' +
      '<div class="quiz-body">' +
        '<div class="edu">' +
          '<div class="edu-badge"><span class="dot"></span>' + data.badge + '</div>' +
          '<h1 class="q-title" style="font-size:26px">' + data.label + '</h1>' +
          '<p class="q-sub">GLP-1 medications activate 5 biological triggers across 2 pathways. Single-ingredient supplements address one.</p>' +
          '<div style="display:flex;flex-direction:column;gap:10px;margin-top:16px">' + rows + '</div>' +
        '</div>' +
      '</div>' +
      '<div class="quiz-footer">' +
        '<button class="btn-primary" data-action="next" disabled>Continue the diagnostic <span class="arrow">→</span></button>' +
      '</div>' +
    '</div>';
  }
  function wireEduTriggers(rootEl, data) {
    rootEl.querySelector('[data-action="back"]').addEventListener('click', goBack);
    var nextBtn = rootEl.querySelector('[data-action="next"]');
    nextBtn.addEventListener('click', function () { if (!nextBtn.disabled) goNext(); });
    var rows = rootEl.querySelectorAll('.trigger-row');
    var revealed = 0;
    var total = data.triggers.length;
    var iv = setInterval(function () {
      if (revealed < total) {
        var row = rows[revealed];
        if (row) { row.style.opacity = '1'; row.style.transform = 'translateX(0)'; }
        revealed++;
        if (revealed >= total) nextBtn.disabled = false;
      } else {
        clearInterval(iv);
      }
    }, 420);
    cleanupFns.push(function () { clearInterval(iv); });
  }

  /* ============== ANALYZING ============== */
  function analyzingHTML() {
    var steps = [
      'Mapping your cortisol profile…',
      'Calculating GAS6 signal disruption…',
      'Evaluating nutrient depletion…',
      'Scoring anchor protein integrity…',
      'Matching your 90-day protocol…'
    ];
    var circ = 2 * Math.PI * 78;
    var stepHTML = '';
    steps.forEach(function (s, i) {
      stepHTML += '<div class="analyze-step" data-i="' + i + '"><span class="bullet"></span><span>' + s + '</span></div>';
    });
    return '' +
    '<div class="quiz-shell">' +
      '<div class="analyze-stage">' +
        '<div class="analyze-ring">' +
          '<svg viewBox="0 0 180 180">' +
            '<circle cx="90" cy="90" r="78" stroke="var(--cream-3)" stroke-width="4" fill="none"></circle>' +
            '<circle class="ring-progress" cx="90" cy="90" r="78" stroke="var(--orange)" stroke-width="4" fill="none" stroke-dasharray="' + circ + '" stroke-dashoffset="' + circ + '" stroke-linecap="round" transform="rotate(-90 90 90)"></circle>' +
          '</svg>' +
          '<div class="pct">0%</div>' +
        '</div>' +
        '<div style="font-family:var(--serif);font-size:22px;font-style:italic;color:var(--ink);margin-bottom:20px">Building your protocol…</div>' +
        '<div style="width:100%;max-width:300px">' + stepHTML + '</div>' +
      '</div>' +
    '</div>';
  }
  function wireAnalyzing(rootEl) {
    var steps = 5;
    var circ = 2 * Math.PI * 78;
    var ring = rootEl.querySelector('.ring-progress');
    var pctEl = rootEl.querySelector('.pct');
    var stepEls = rootEl.querySelectorAll('.analyze-step');
    var dur = 5200, t0 = performance.now(), raf, done = false, timeoutId;
    function tick(t) {
      var p = Math.min(1, (t - t0) / dur);
      var pct = Math.round(p * 100);
      var step = Math.min(steps - 1, Math.floor(p * steps));
      pctEl.textContent = pct + '%';
      ring.setAttribute('stroke-dashoffset', String(circ * (1 - pct / 100)));
      stepEls.forEach(function (el, i) {
        el.className = 'analyze-step ' + (i === step ? 'active' : i < step ? 'done' : '');
      });
      if (p < 1) { raf = requestAnimationFrame(tick); }
      else { done = true; timeoutId = setTimeout(goNext, 400); }
    }
    raf = requestAnimationFrame(tick);
    cleanupFns.push(function () { cancelAnimationFrame(raf); if (timeoutId) clearTimeout(timeoutId); });
  }

  /* ============== RESULTS · profile computation ============== */
  function computeProfile(answers) {
    var stress = answers.stress || 2;
    var shedding = answers.shedding || 2;
    var duration = answers.duration;
    var goal = answers.goal;

    var name = 'The Stress-Thinner';
    var trigger = 'Growth Signal Suppression';
    var subtitle = 'Cortisol is suffocating your follicles. Your shot is amplifying the damage.';
    var blurb = [
      'Your stress score and shedding pattern point to a <strong>cortisol-driven hair loss cycle</strong>. Elevated cortisol activates glucocorticoid receptors in your dermal papilla cells, which suppresses <strong>GAS6</strong>... the molecule identified in a 2021 Nature study as the specific signal that tells follicle stem cells to stay in growth mode. Without <strong>GAS6</strong>, stem cells stay locked in resting phase.',
      'GLP-1s pour fuel on this fire. The metabolic load of rapid weight loss spikes cortisol further. Your follicles stop receiving the activation signal entirely.',
      'Single-ingredient supplements (<strong>biotin</strong>, <strong>collagen</strong>, <strong>rosemary oil</strong>) miss the root cause. They don\'t address cortisol. They don\'t restore <strong>GAS6</strong> signaling.',
      '<strong>Your protocol is anchored by Shoden® Ashwagandha at 60mg clinical dose.</strong> Shoden drops cortisol 65.78% in 60 days... unlocking GAS6 signaling so the rest of the formula can do its job. keraGEN-iV rebuilds the strands you\'ve already lost.'
    ];
    var primaryIngredients = ['ashwagandha', 'vitamins', 'keratin'];

    if (goal === 'keep-shot') {
      name = 'The Trade-Off';
      trigger = 'Both Active (Convergence)';
      subtitle = 'You love your results. Your hair is the price... but it doesn\'t have to be.';
      blurb = [
        'You\'ve made it clear. <strong>The shot stays.</strong> That means your hair loss isn\'t a "pause the medication" problem... it\'s a <strong>protect-the-follicle</strong> problem.',
        'Both GLP-1 triggers are firing at once in your follicles right now. <strong>Metabolic Follicle Disruption</strong> is breaking down the anchor proteins (<strong>keratin</strong> and <strong>collagen IV</strong>) that hold each strand. <strong>Growth Signal Suppression</strong> is locking your follicle stem cells in resting phase by suppressing <strong>GAS6</strong>. Your protocol has to address both at the same time, without interfering with the medication.',
        '<strong>Your protocol leads with keraGEN-iV and Shoden® Ashwagandha at clinical doses.</strong> keraGEN-iV rebuilds the anchor proteins so the strands you grow stay in. Shoden drops cortisol 65.78% in 60 days so your follicles can come out of resting phase. zeropollution® neutralizes the toxin load from rapid weight loss.'
      ];
      primaryIngredients = ['keratin', 'ashwagandha', 'zeropollution'];
    } else if (shedding >= 4) {
      name = 'The Shedder';
      trigger = 'Metabolic Follicle Disruption';
      subtitle = 'You\'re in the peak shedding window. Your follicles have already lost grip on the strand.';
      blurb = [
        'The anchor proteins that hold each hair in place... <strong>keratin</strong> and <strong>collagen IV</strong>... are breaking down faster than your body can rebuild them. This is the metabolic side of GLP-1 hair loss, not the signal side. Rapid weight loss dumped stored toxins, inflammatory signals, and nutrient debt into your bloodstream faster than your follicles could absorb the hit. The anchors gave first.',
        '<strong>Every week without intervention compounds the loss.</strong>',
        '<strong>Your protocol leads with keraGEN-iV at clinical dose.</strong> keraGEN-iV cuts hair fall 43.1% in 60 days by rebuilding the exact anchor proteins your follicles need. Shoden® Ashwagandha drops the cortisol that\'s accelerating the breakdown.'
      ];
      primaryIngredients = ['keratin', 'biotin', 'ashwagandha'];
    } else if (duration === '3to6') {
      name = 'The Cliff Edge';
      trigger = 'Growth Signal Suppression (incoming)';
      subtitle = 'You\'re at the 3-6 month cliff. The shedding surge is coming. Let\'s get ahead of it.';
      blurb = [
        '<strong>Month 3 to 6 on a GLP-1</strong> is when most women hit the cliff. The cortisol-and-nutrient debt from rapid weight loss finally catches up to your follicles. What feels like normal hair fall this week becomes clumps in <strong>4-8 weeks</strong>.',
        'The pathway in front of you is <strong>Growth Signal Suppression</strong>. Cortisol is already starting to block <strong>GAS6</strong>... the molecule that tells follicle stem cells to stay in growth mode. Once <strong>GAS6</strong> drops below threshold, follicles enter a synchronized resting phase. That\'s the surge you\'re heading toward.',
        'Starting now means you <strong>intercept the surge before it becomes visible thinning</strong>, instead of trying to recover from it 6 months from now. <strong>Pre-emptive is 3x more effective than reactive.</strong>',
        '<strong>Your protocol leads with Shoden® Ashwagandha at clinical dose</strong> to drop cortisol before GAS6 collapses, paired with keraGEN-iV to fortify anchors before the shedding wave hits.'
      ];
      primaryIngredients = ['ashwagandha', 'keratin', 'vitamins'];
    }

    var medMap = { ozempic: 'Ozempic', wegovy: 'Wegovy', mounjaro: 'Mounjaro', zepbound: 'Zepbound', other: 'GLP-1' };
    var durMap = { lt3: 'under 3 months', '3to6': '3–6 months', '6to12': '6–12 months', gt12: 'over a year' };
    var durTagMap = { lt3: 'pre-shedding window', '3to6': 'peak shedding window', '6to12': 'chronic phase', gt12: 'long-term phase' };
    var shedLabelMap = { 1: 'Mild shedding', 2: 'Slightly elevated shedding', 3: 'Noticeable shedding', 4: 'Heavy shedding · handfuls', 5: 'Severe shedding · clumps' };
    var partTagMap = { alot: 'visible scalp at the part', yes: 'visibly wider part', slight: 'slightly wider part', no: 'density still intact' };
    var stressLabelMap = { 1: 'Manageable stress', 2: 'Moderate stress', 3: 'High stress', 4: 'Through-the-roof cortisol' };
    var weightLabelMap = { '<15': 'Under 15 lbs lost', '15-30': '15–30 lbs lost', '30-50': '30–50 lbs lost', '50+': 'Over 50 lbs lost' };
    var sleepLabelMap = { good: 'Sleeping deeply', ok: 'Decent 6–7 hr sleep', broken: 'Broken sleep', bad: 'Sleep-deprived' };
    var ageTagMap = { '18-24': 'estrogen still peak', '25-34': 'follicle environment stable', '35-44': 'estrogen beginning to dip', '45-54': 'perimenopausal hormone shift', '55+': 'estrogen drop amplifying loss' };
    var ageLabelMap = { '18-24': 'Age 18–24', '25-34': 'Age 25–34', '35-44': 'Age 35–44', '45-54': 'Age 45–54', '55+': 'Age 55+' };

    var personalBullets = [];
    if (answers.glp1 && answers.duration) {
      personalBullets.push({ label: 'On ' + (medMap[answers.glp1] || 'GLP-1') + ' for ' + durMap[answers.duration], tag: durTagMap[answers.duration] });
    }
    if (answers.shedding) {
      personalBullets.push({ label: shedLabelMap[answers.shedding] || 'Active shedding', tag: partTagMap[answers.part] || 'tracking density loss' });
    }
    if (answers.stress) {
      personalBullets.push({ label: stressLabelMap[answers.stress] || 'Cortisol elevated', tag: (answers.stress || 0) >= 3 ? 'cortisol blocking GAS6' : 'cortisol creeping up on follicles' });
    }
    if (answers.weight) {
      personalBullets.push({ label: weightLabelMap[answers.weight] || 'Active weight loss', tag: 'metabolic load on follicles' });
    }
    if (answers.sleep) {
      personalBullets.push({ label: sleepLabelMap[answers.sleep] || 'Sleep tracking', tag: (answers.sleep === 'bad' || answers.sleep === 'broken') ? 'keratin repair window cut short' : 'deep-sleep keratin repair on track' });
    }
    if (answers.age) {
      personalBullets.push({ label: ageLabelMap[answers.age] || ('Age ' + answers.age), tag: ageTagMap[answers.age] || 'follicle environment shifting' });
    }

    var triedSelections = Array.isArray(answers.tried) ? answers.tried : [];
    var triedOptions = (QUIZ_DATA.questions.filter(function (q) { return q.id === 'tried'; })[0] || {}).options || [];
    var lib = QUIZ_DATA.dropListLibrary || {};
    var triedLabels = triedSelections.map(function (v) {
      return (triedOptions.filter(function (o) { return o.v === v; })[0] || {}).label;
    }).filter(Boolean);
    var dropList = triedLabels.indexOf('Nothing yet') !== -1
      ? []
      : triedLabels.filter(function (label) { return lib[label]; }).map(function (label) { return { label: label, why: lib[label] }; });

    return { name: name, trigger: trigger, subtitle: subtitle, blurb: blurb, primaryIngredients: primaryIngredients, personalBullets: personalBullets.slice(0, 5), dropList: dropList };
  }

  function computeTriggers(answers) {
    var s = answers.shedding || 1;
    var st = answers.stress || 1;
    var sl = answers.sleep === 'bad' ? 4 : answers.sleep === 'broken' ? 3 : answers.sleep === 'ok' ? 2 : 1;
    var w = answers.weight === '50+' ? 4 : answers.weight === '30-50' ? 3 : answers.weight === '15-30' ? 2 : 1;
    var p = answers.part === 'alot' ? 4 : answers.part === 'yes' ? 3 : answers.part === 'slight' ? 2 : 1;
    var a = answers.age === '55+' ? 4 : answers.age === '45-54' ? 3 : answers.age === '35-44' ? 2 : 1;
    return [
      { name: 'The Cortisol Crash', score: 40 + st * 15, tag: 'Stress hormone shutting down growth', stat: 'Spikes during rapid fat loss', what: 'Stress hormones spike when your body is rapidly losing fat. Cortisol blocks GAS6, the molecule that tells your follicles to keep growing... so they shut down and shed.', fix: 'Shoden® ashwagandha lowers cortisol 66% in 60 days.' },
      { name: 'The Slipping Strands', score: 30 + s * 10 + p * 8, tag: 'Strands sliding out at the root', stat: 'Keratin loss accelerates', what: 'The keratin and collagen IV proteins that hold each strand into your scalp are breaking down faster than your body rebuilds them... so healthy-looking hairs slide out.', fix: 'keraGEN-IV® rebuilds the anchor proteins at the root.' },
      { name: 'The Detox Dump', score: 30 + w * 16, tag: 'Stored toxins flooding your scalp', stat: 'Released during fat loss', what: 'Rapid fat loss dumps stored toxins back into your bloodstream. They circulate to your scalp and create oxidative chaos around the follicles.', fix: 'zeropollution® clinically protects scalp cells from pollution-induced oxidative damage.' },
      { name: 'The Nutrient Drain', score: 45 + w * 10, tag: 'Follicles starved of fuel', stat: 'Iron, zinc, biotin low', what: 'Eating less means your body diverts iron, zinc, biotin, and protein to vital organs first. Your follicles, nails, and skin starve before anything else.', fix: 'Clinical doses of biotin, zinc, copper restore the supply.' },
      { name: 'The Sleep Debt', score: 30 + sl * 15, tag: 'Repair cycle interrupted', stat: 'Deep sleep rebuilds keratin', what: 'Follicles rebuild keratin during deep sleep. Broken or short sleep means weaker strands and slower regrowth, day after day.', fix: 'Shoden® improves sleep depth and recovery cycles.' },
      { name: 'The Oxidative Burn', score: 35 + Math.max(st, s) * 12, tag: 'Free radicals damaging new hair', stat: 'Growth cycles lost', what: 'Oxidative stress damages the cells that make new hair. The longer it goes unchecked, the more growth cycles you lose.', fix: 'Vitamins C + E shield follicles from free radical damage.' },
      { name: 'The Estrogen Cliff', score: 28 + a * 14, tag: 'Estrogen drop amplifying loss', stat: 'DHT sensitivity rising', what: 'Estrogen drops with age and amplifies follicle sensitivity to cortisol and DHT. GLP-1 weight loss accelerates the hormonal rollercoaster.', fix: 'Multi-pathway formula stabilizes the follicle environment.' }
    ].map(function (t) { t.score = Math.min(94, t.score); return t; });
  }

  var RESULTS_TIMELINE = [
    { week: 'WEEK 1–2', phase: 'Foundation Phase', detail: 'Shedding slows. Ashwagandha lowers cortisol. Antioxidants neutralize toxin surge from your weight loss.' },
    { week: 'WEEK 3–6', phase: 'Strengthening', detail: 'Hairbrush clears up. keraGEN-IV® rebuilds disulfide bonds. Breakage drops. Scalp feels lighter.' },
    { week: 'WEEK 7–12', phase: 'Clinical Window', detail: 'keraGEN-IV® hits its clinical mark: 43.1% less hair fall vs placebo at 60 days.' },
    { week: 'WEEK 12+', phase: 'Full Cycle Complete', detail: 'Ingredients have had a full hair-growth cycle to work. All on your shot, without quitting.' }
  ];

  var RESULTS_TESTIMONIALS = [
    { img: RIMG.port_1, headline: 'New baby hairs and visible new growth.', quote: 'I have so many new baby hairs... NEW GROWTH. My curls are softer and shinier. I\'m an official convert.', name: 'Nikki H.', detail: 'Down 38 lbs · Ozempic' },
    { img: RIMG.port_2, headline: 'The shedding stopped completely.', quote: 'Three months on KeraLush and the shedding stopped completely. I didn\'t have to choose anymore.', name: 'Gigi', detail: 'Down 46 lbs · Wegovy' },
    { img: RIMG.port_3, headline: 'Breakage has noticeably decreased.', quote: 'My hair feels healthier, smoother, and more hydrated. Breakage has noticeably decreased.', name: 'Rachel W.', detail: 'Down 52 lbs · Mounjaro' },
    { img: RIMG.port_4, headline: 'New growth where I had thinned.', quote: 'Definitely noticed nail growth, better sleep, and new hair growth in spots that were menopausal thinning.', name: 'Kimberly', detail: 'Down 27 lbs · Zepbound' }
  ];

  var RESULTS_FAILURES = [
    { n: 'Biotin gummies', w: 'Solves nutrient gap only. Ignores cortisol, anchor proteins, and oxidation entirely.' },
    { n: 'Collagen powder', w: 'Generic Type I collagen... your follicles need Type IV at the anchor point. Wrong target.' },
    { n: 'Minoxidil and topicals', w: 'Pushes follicles to grow while the root cause keeps shutting them down. You shed harder when you stop.' },
    { n: '"Hair, skin & nails" multis', w: 'Sub-clinical doses spread across 30 ingredients. None hit the threshold to actually work.' },
    { n: 'Stopping the shot', w: 'You\'d lose the metabolic progress... and the cortisol crash from rebound weight gain often makes hair loss worse.' }
  ];

  var RESULTS_INGREDIENTS = [
    { key: 'keratin', match: 'keratin', img: RIMG.ig_keratin, name: 'keraGEN-IV® Keratin', dose: 'In 770mg proprietary blend', claim: 'Clinically shown to cut hair fall 43.1% vs placebo at 60 days.', why: 'Rebuilds the anchor proteins your follicles need to hold each strand in place.', benefits: ['Brush and shower drains start clearing', 'Thicker, more resilient new growth', 'Hairline density fills back in'] },
    { key: 'ashwagandha', match: 'ashwagandha', img: RIMG.ig_ashwagandha, name: 'Shoden® Ashwagandha', dose: 'In 770mg proprietary blend', claim: 'Drops cortisol 66% in 60 days... the stress hormone GLP-1s spike that drives your shed.', why: 'Calms the cortisol-driven follicle shutdown so growth signals can switch back on.', benefits: ['Deeper sleep, fewer 3am wakeups', 'Less reactive scalp and skin', 'Follicles re-enter the growth phase'] },
    { key: 'zeropollution', match: 'zeropollution', img: RIMG.ig_zeropollution, name: 'zeropollution® Botanicals', dose: 'In 770mg proprietary blend', claim: 'Patented antioxidant complex clinically shown to shield scalp cells from pollution-driven oxidative damage.', why: 'Mops up the toxins your body releases from rapid fat loss before they damage follicles.', benefits: ['Calmer roots, less itch and irritation', 'Protects new growth during rapid weight loss', 'Scalp feels lighter and less inflamed'] },
    { key: 'biotin', match: 'biotin', img: RIMG.ig_biotin, name: 'Biotin', dose: '2,500 mcg per day · 8,333% DV', claim: 'Direct building block your follicles use to assemble keratin... at 80x daily value to overcome appetite-driven gaps.', why: 'The B vitamin your hair runs on. Low biotin shows up as brittle, slow-growing strands.', benefits: ['Stronger nail beds and cuticles', 'Faster, more even regrowth', 'Less breakage on washing'] },
    { key: 'pantothenic', match: 'biotin', img: RIMG.ig_pantothenic, name: 'Pantothenic Acid (B5)', dose: '100 mg per day · 2,000% DV', claim: 'Foundational B vitamin involved in coenzyme A and the fatty acids that condition your scalp.', why: 'Replenishes the B vitamin most easily depleted by appetite suppression, alongside biotin.', benefits: ['Softer, smoother hair texture', 'Reduced scalp dryness', 'Better shine without weighing strands down'] },
    { key: 'zinc', match: 'biotin', img: RIMG.ig_zinc, name: 'Zinc', dose: '15 mg per day · 136% DV', claim: 'Cofactor in over 100 enzymatic reactions tied to hair growth and tissue repair.', why: 'Low zinc is one of the most-cited mineral deficiencies in clinical hair-loss patients.', benefits: ['Supports new follicle activity', 'Strengthens the hair shaft', 'Calms a flaky, irritated scalp'] },
    { key: 'copper', match: 'biotin', img: RIMG.ig_copper, name: 'Copper', dose: '1.7 mg per day · 189% DV', claim: 'Required for melanin synthesis and the cross-links that give hair its tensile strength.', why: 'GLP-1 weight loss often pairs zinc loss with copper loss... we replace both in balance.', benefits: ['Helps preserve natural hair color', 'Stronger strand structure', 'Supports collagen formation'] },
    { key: 'vitamin_c', match: 'vitamins', img: RIMG.ig_vitamin_c, name: 'Vitamin C', dose: '90 mg per day · 100% DV', claim: 'Required cofactor in collagen synthesis... no vitamin C, no new follicle scaffolding.', why: 'Recycles vitamin E so the antioxidant system keeps running during rapid weight loss.', benefits: ['Stronger follicle structure', 'Brighter, more even skin tone', 'Better iron absorption from food'] },
    { key: 'vitamin_e', match: 'vitamins', img: RIMG.ig_vitamin_e, name: 'Vitamin E', dose: '100 mg per day · 667% DV', claim: 'Lipid-soluble antioxidant proven to protect cell membranes from oxidative damage.', why: 'Sits in the scalp\'s lipid layer guarding follicle membranes from the toxin surge.', benefits: ['Protects new growth from breakage', 'Maintains the scalp barrier', 'Supports circulation to follicles'] }
  ];

  var RESULTS_FAQ = [
    { q: 'How long before I see results?', a: 'Most women notice reduced shedding within the first 2 to 3 weeks as antioxidants begin neutralizing oxidative damage and ashwagandha starts lowering cortisol. By week 6 to 8, you\'ll feel the difference... hair texture improves, breakage decreases. The most dramatic transformation happens at 60 to 90 days, which aligns with a complete hair growth cycle. In the keraGEN-IV® clinical trial, women experienced a 43.1% reduction in hair loss at 60 days.' },
    { q: 'Is KeraLush safe to take alongside my GLP-1?', a: 'KeraLush is 100% drug-free vitamins, minerals, and botanicals... no hormones, no harsh chemicals, no synthetic compounds. There are no known interactions with GLP-1 medications like Ozempic, Wegovy, Mounjaro, or Zepbound. Every ingredient has been tested for safety and every batch is third-party tested for purity at NSF and GMP certified facilities. We always recommend mentioning any new supplement to the prescriber managing your GLP-1, especially if you\'ve had recent dose changes.' },
    { q: 'Can I take this with other supplements or medications?', a: 'KeraLush is formulated to complement most supplement regimens. That said, if you\'re taking prescription medications... particularly blood thinners, thyroid medication, hormone replacement therapy, or immunosuppressants... we recommend consulting your healthcare provider first. Your doctor knows your complete health picture and can confirm there are no contraindications specific to your situation.' },
    { q: 'What if it doesn\'t work for me?', a: 'We stand behind the science with a 90-day money-back guarantee. If you don\'t experience noticeable improvements in hair thickness, reduced shedding, or overall hair vitality, contact us at support@rejuveen.com for a full refund... no questions asked. You can keep any unopened bottles. We\'ve seen the clinical data. We know this works for the vast majority of women. But bodies are unique, and we respect that.' },
    { q: 'Why is KeraLush better than just taking biotin?', a: 'Biotin addresses one piece of the puzzle... nutrient deficiency. But GLP-1-related hair loss tends to be multifactorial. There\'s rapid weight loss spiking cortisol and disrupting GAS6 signaling. There\'s appetite suppression that can leave follicles short on zinc, copper, and B vitamins. And there\'s the toxin load released from rapid fat loss. KeraLush is designed to address several of these triggers together, which is why women often see more improvement than from single-ingredient biotin alone.' },
    { q: 'How is this different from minoxidil or prescription treatments?', a: 'Minoxidil is a topical vasodilator that increases blood flow to the scalp. It doesn\'t address the underlying biology driving GLP-1-related shedding. KeraLush works from the inside out, targeting the nutritional and cortisol-related drivers. Many women use both together. Unlike prescription DHT blockers like finasteride (which carry hormonal side-effect risks and aren\'t FDA-approved for women), KeraLush is 100% drug-free and hormone-neutral, and is generally well tolerated.' },
    { q: 'Do I need to take this forever?', a: 'For optimal results, ongoing use is best. The triggers that damage your follicles... chronic stress, environmental pollution, hormonal fluctuations, ongoing GLP-1 use... are persistent. They don\'t stop just because you\'ve completed 90 days. Continuous nutritional support helps your body maintain the improvements you\'ve achieved. That said, many women find their hair stays healthier for months even after stopping, unlike topical treatments that require lifelong daily application.' },
    { q: 'Is this only for women on GLP-1s?', a: 'KeraLush was specifically formulated to address the hormonal, inflammatory, and nutritional triggers driving hair loss in women on GLP-1s, but younger women experiencing stress-induced shedding, postpartum hair loss, or early-onset thinning benefit significantly as well. The clinical ingredients work regardless of age because they target universal biological pathways. If your follicles are under stress, these nutrients provide support.' },
    { q: 'What\'s the best way to take KeraLush?', a: 'Take 2 capsules daily with a meal... preferably breakfast or lunch... and a full glass of water. Consistency matters more than timing, so pick a time you\'ll remember and stick with it. Pro tip: avoid taking KeraLush with coffee or calcium supplements, as both can interfere with nutrient absorption. And give it the full 60 to 90 days. Hair regrowth is a biological process. You\'re rebuilding follicle health from the cellular level up.' },
    { q: 'Can I use this if I have thyroid issues or PCOS?', a: 'Many women with thyroid dysfunction or PCOS use KeraLush successfully. In fact, hormonal imbalances are among the primary drivers of hair loss in both conditions. The adaptogenic properties of Shoden® ashwagandha can help support healthy cortisol balance, and the antioxidants protect follicles. However, if you\'re on thyroid medication (levothyroxine) or metformin, please consult your endocrinologist before starting. Timing of supplementation may need adjustment to avoid interference with medication absorption.' },
    { q: 'What makes the ingredients in KeraLush \'clinical-strength\'?', a: 'Clinical-strength means we use the exact forms and dosages tested in published human trials. Our keraGEN-IV® keratin is the same form that achieved a 43.1% reduction in hair loss in a double-blind, placebo-controlled study. Our zeropollution® blend delivers the antioxidant complex shown to protect scalp cells from pollution-driven oxidative damage. We don\'t use fairy-dusted amounts. Every ingredient is dosed to deliver the results seen in the research.' }
  ];

  // Results-scoped local state
  var resPlan = '90';
  var resOfferStep = 1;

  /* ---------- OFFER STEPS ---------- */
  function offerStep1HTML(plan) {
    var packsHTML = '';
    PACKAGES.forEach(function (p) {
      var isFeatured = p.k === '90';
      var isStarter = p.k === '30';
      var isSelected = plan === p.k;
      var inner = '';
      if (p.badge) inner += '<span class="pack-badge' + (isFeatured ? ' gold' : '') + '">' + p.badge + '</span>';
      if (isFeatured) inner += '<span class="pack-savings">SAVE $' + (p.strike - p.total) + '</span>';
      inner += '<div class="pack-main">' +
        '<div class="pack-img">' + heroPic({ src: p.bundle, alt: p.months, sizes: '86px' }) + '</div>' +
        '<div class="pack-meta">' +
          '<div class="pack-months">' + p.months + '</div>' +
          '<div class="pack-per">' + p.per + '<span class="pack-per-unit">/day</span></div>' +
          '<div class="pack-price-row"><span class="pack-total">$' + p.total + ' total</span><span class="pack-strike">$' + p.strike + '</span><span class="pack-save">Save ' + p.save + '%</span></div>' +
          '<div class="pack-coupon-inline"><span class="pc-tag">+ EXTRA $10 OFF</span><span class="pc-txt">auto-applied at checkout</span></div>' +
          (isStarter ? '<div class="pack-warn">Recommended for return customers. A full 90-day hair cycle is recommended for first-time results.</div>' : '') +
        '</div>' +
        '<div class="pack-radio"><span></span></div>' +
      '</div>';
      if (isFeatured) {
        inner += '<div class="pack-coupon"><span class="pc-tag">+ EXTRA $10 OFF</span><span class="pc-txt">auto-applied at checkout</span></div>';
        inner += '<div class="pack-extras">' +
          '<div class="pack-extras-title">Everything in the 90-day protocol:</div>' +
          '<ul class="pack-extras-list">' +
            '<li><span class="pe-tick">✓</span>3 bottles, one full hair-growth cycle... no gaps, no restarting</li>' +
            '<li><span class="pe-tick">✓</span><strong>Free US shipping</strong> + priority dispatch</li>' +
            '<li><span class="pe-tick">✓</span>Pause or cancel anytime, no phone calls</li>' +
          '</ul>' +
          '<button type="button" class="btn-primary pack-cta" data-offer="continue">Start my 90-day hair transformation <span class="arrow">→</span></button>' +
          '<div class="pack-social"><span class="ps-dot"></span><strong>Most women start here</strong> for full-cycle results</div>' +
        '</div>';
      }
      if (!isFeatured) {
        inner += '<div class="pack-coupon"><span class="pc-tag">+ EXTRA $10 OFF</span><span class="pc-txt">auto-applied at checkout</span></div>';
        inner += '<button type="button" class="btn-primary pack-cta pack-cta-inline" data-offer="continue">Continue to my order <span class="arrow">→</span></button>';
      }
      packsHTML += '<div role="button" tabindex="0" aria-pressed="' + (isSelected ? 'true' : 'false') + '" ' +
        'class="offer-pack offer-pack--' + attr(p.k) + (isSelected ? ' selected' : '') + (isFeatured ? ' featured' : '') + (isStarter ? ' starter' : '') + '" ' +
        'data-pack="' + attr(p.k) + '">' + inner + '</div>';
    });

    return '' +
    '<div class="offer-step" data-screen-label="Offer · Step 1">' +
      '<div class="offer-header">' +
        '<div class="offer-step-badge">STEP 1 OF 2 · SELECT YOUR SUPPLY</div>' +
        '<h2 class="offer-h">Choose your <em>transformation plan</em></h2>' +
        '<p class="offer-sub">Hair grows on a 90-day cycle. To give the formula a full window to work, you need three full bottles. Most women start here for full-cycle results.</p>' +
      '</div>' +
      '<div class="why90">' +
        '<div class="why90-title">WHY 90 DAYS IS THE PROTOCOL</div>' +
        '<div class="why90-row">' +
          '<div class="why90-step"><div class="why90-num">30</div><div class="why90-label">Shedding slows</div><div class="why90-sub">Cleaner pillow, less in the drain.</div></div>' +
          '<div class="why90-arrow">→</div>' +
          '<div class="why90-step"><div class="why90-num">60</div><div class="why90-label">Hair fall cut nearly in half</div><div class="why90-sub">End of the clinical trial window.</div></div>' +
          '<div class="why90-arrow">→</div>' +
          '<div class="why90-step highlight"><div class="why90-num">90</div><div class="why90-label">Full hair-growth cycle complete</div><div class="why90-sub">Ingredients have had time to do their work.</div></div>' +
        '</div>' +
      '</div>' +
      '<div class="offer-packs">' + packsHTML + '</div>' +
      '<div class="offer-perks">' +
        '<div class="perk"><span class="pk">✓</span> 90-day money-back guarantee... even the empty bottles</div>' +
        '<div class="perk"><span class="pk">✓</span> Free US shipping on 2+ bottles</div>' +
        '<div class="perk"><span class="pk">✓</span> Made in FDA-registered, GMP-certified US facility</div>' +
        '<div class="perk"><span class="pk">✓</span> Zero known interactions with GLP-1 medications</div>' +
      '</div>' +
      '<div class="offer-foot">SSL secured checkout · 256-bit encryption</div>' +
    '</div>';
  }

  function offerStep2HTML(plan) {
    var p = PACKAGES.filter(function (x) { return x.k === plan; })[0];
    return '' +
    '<div class="offer-step" data-screen-label="Offer · Step 2">' +
      '<div class="offer-header">' +
        '<div class="offer-step-badge">STEP 2 OF 2 · REVIEW & CHECKOUT</div>' +
        '<h2 class="offer-h">Your personalized <em>hair protocol</em></h2>' +
      '</div>' +
      '<div class="order-card" id="offer-order-summary">' +
        '<div class="order-top">' +
          '<div class="order-img">' + heroPic({ src: p.bundle, alt: p.months, sizes: '70px' }) + '</div>' +
          '<div class="order-info">' +
            '<div class="order-name">KeraLush™</div>' +
            '<div class="order-months">' + p.months + ' · ' + p.bottles + ' ' + (p.bottles === 1 ? 'bottle' : 'bottles') + '</div>' +
            '<div class="order-per">' + p.per + ' per serving</div>' +
          '</div>' +
          '<div class="order-price"><div class="op-total">$' + p.total + '</div><div class="op-strike">$' + p.strike + '</div></div>' +
        '</div>' +
        '<div class="order-line"></div>' +
        '<div class="order-rows">' +
          '<div class="or"><span>Subtotal</span><span>$' + p.strike + '.00</span></div>' +
          '<div class="or"><span>Your ' + p.save + '% discount</span><span style="color:var(--orange)">−$' + (p.strike - p.total) + '.00</span></div>' +
          '<div class="or"><span>Shipping</span><span>' + (p.bottles >= 2 ? 'FREE' : '$4.95') + '</span></div>' +
          '<div class="or total"><span>Total</span><span>$' + p.total + '.00</span></div>' +
        '</div>' +
      '</div>' +
      '<div class="order-includes">' +
        '<div class="oi-title">Included with your order:</div>' +
        '<div class="oi-row"><img src="' + attr(RIMG.money_back) + '" alt=""><div>90-day money-back guarantee</div></div>' +
        '<div class="oi-row"><span class="oi-icon">✦</span><div>Free access to our GLP-1 hair care guide (digital)</div></div>' +
        '<div class="oi-row"><span class="oi-icon">⚡</span><div>Priority customer support from our wellness team</div></div>' +
      '</div>' +
      '<button class="btn-primary btn-checkout" data-offer="checkout">🔒 Complete my order · $' + p.total + '</button>' +
      '<button class="btn-text" data-offer="back">← Change my plan</button>' +
    '</div>';
  }

  function offerWrapInnerHTML() {
    var prog = '';
    [1, 2].forEach(function (n) {
      prog += '<div class="op-step' + (resOfferStep >= n ? ' active' : '') + (resOfferStep === n ? ' current' : '') + '">' +
        '<span class="op-num">' + (resOfferStep > n ? '✓' : n) + '</span>' +
        '<span class="op-lbl">' + (n === 1 ? 'Select' : 'Review & Checkout') + '</span></div>';
    });
    var stepHTML = resOfferStep === 1 ? offerStep1HTML(resPlan) : offerStep2HTML(resPlan);
    return '<div class="offer-progress">' + prog + '</div>' + stepHTML;
  }

  function renderOffer(profile, doScroll) {
    var wrap = document.getElementById('offer-anchor');
    if (!wrap) return;
    wrap.innerHTML = offerWrapInnerHTML();
    wireOffer(wrap, profile);
    if (doScroll) scrollToId(resOfferStep === 2 ? 'offer-order-summary' : 'offer-anchor');
  }

  function wireOffer(wrap, profile) {
    if (resOfferStep === 1) {
      var allPacks = wrap.querySelectorAll('.offer-pack');
      allPacks.forEach(function (pack) {
        var select = function () {
          var newPlan = pack.getAttribute('data-pack');
          if (newPlan === resPlan) return;
          resPlan = newPlan;
          allPacks.forEach(function (p) {
            var isSel = p.getAttribute('data-pack') === resPlan;
            p.classList.toggle('selected', isSel);
            p.setAttribute('aria-pressed', String(isSel));
          });
        };
        pack.addEventListener('click', function (e) {
          if (e.target.closest('[data-offer="continue"]')) return;
          select();
        });
        pack.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(); }
        });
      });
      var lastContinueTap = 0;
      function continueToReview(e) {
        var now = Date.now();
        if (e.type === 'click' && now - lastContinueTap < 700) return;
        if (e.type === 'touchend') lastContinueTap = now;
        e.preventDefault();
        e.stopPropagation();
        resOfferStep = 2; renderOffer(profile, true);
      }
      wrap.querySelectorAll('[data-offer="continue"]').forEach(function (btn) {
        btn.addEventListener('click', continueToReview);
        btn.addEventListener('touchend', continueToReview, { passive: false });
      });
    } else if (resOfferStep === 2) {
      var lastCheckoutTap = 0;
      function completeOrder(e) {
        var now = Date.now();
        if (e.type === 'click' && now - lastCheckoutTap < 700) return;
        if (e.type === 'touchend') lastCheckoutTap = now;
        e.preventDefault();
        e.stopPropagation();
        checkout(profile, '', '');
      }
      var checkoutBtn = wrap.querySelector('[data-offer="checkout"]');
      checkoutBtn.addEventListener('click', completeOrder);
      checkoutBtn.addEventListener('touchend', completeOrder, { passive: false });

      var lastBackTap = 0;
      function backToPlans(e) {
        var now = Date.now();
        if (e.type === 'click' && now - lastBackTap < 700) return;
        if (e.type === 'touchend') lastBackTap = now;
        e.preventDefault();
        e.stopPropagation();
        resOfferStep = 1; renderOffer(profile, true);
      }
      var backBtn = wrap.querySelector('[data-offer="back"]');
      backBtn.addEventListener('click', backToPlans);
      backBtn.addEventListener('touchend', backToPlans, { passive: false });
    }
  }

  function buildCheckoutPermalink(p, quizProps, sellingPlanId, discountParam) {
    var propsQuery = '';
    Object.keys(quizProps).forEach(function (key) {
      var val = quizProps[key];
      if (!val) return;
      propsQuery += '&properties[' + encodeURIComponent(key) + ']=' + encodeURIComponent(val);
    });

    var addUrl = '/cart/add'
      + '?id=' + encodeURIComponent(p.variantId)
      + '&quantity=1';

    if (sellingPlanId) {
      addUrl += '&selling_plan=' + encodeURIComponent(sellingPlanId);
    }

    addUrl += propsQuery
      + '&return_to=' + encodeURIComponent('/checkout' + discountParam);

    return '/cart/clear?return_to=' + encodeURIComponent(addUrl);
  }

  function triggerUpsellPopup(p, quizProps, otpUrl, discountParam) {
    if (!UPSELL.enabled || !UPSELL.sectionId) return false;

    var offerKey = 'bundle' + p.k;
    var offer = UPSELL.offers && UPSELL.offers[offerKey];
    if (!offer || !offer.sellingPlanId) return false;

    var subUrl = buildCheckoutPermalink(p, quizProps, offer.sellingPlanId, discountParam);
    var trigger = document.createElement('a');
    trigger.href = otpUrl;
    trigger.className = 'otp-upsell-trigger';
    trigger.setAttribute('data-upsell-section-id', UPSELL.sectionId);
    trigger.setAttribute('data-otp-url', otpUrl);
    trigger.setAttribute('data-sub-url', subUrl);
    trigger.setAttribute('data-pkg-qty', String(p.bottles || 1));
    trigger.setAttribute('data-sub-price', offer.subPrice || '');
    trigger.setAttribute('data-save-pct', offer.savePct || '');
    trigger.setAttribute('data-sub-type', offer.subType || '');
    trigger.setAttribute('data-sub-unit', offer.subUnit || '');
    trigger.style.position = 'absolute';
    trigger.style.left = '-9999px';
    trigger.style.width = '1px';
    trigger.style.height = '1px';
    document.body.appendChild(trigger);

    var upsellInstance = window.__otpUpsellStore &&
      window.__otpUpsellStore.instances &&
      window.__otpUpsellStore.instances[UPSELL.sectionId];

    if (upsellInstance && typeof upsellInstance.open === 'function') {
      upsellInstance.open(trigger);
    } else {
      try {
        var clickEvent = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
        trigger.dispatchEvent(clickEvent);
      } catch (e) {
        trigger.click();
      }
    }

    setTimeout(function () {
      if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
    }, 0);

    return true;
  }

  function triggerBogoPopup(p, otpUrl) {
    if (!BOGO.enabled || !BOGO.sectionId) return false;
    var bogoStore = window.__subBogoUpsellStore;
    if (!bogoStore || typeof bogoStore.open !== 'function') return false;

    var trigger = document.createElement('a');
    trigger.href = otpUrl;
    trigger.setAttribute('data-otp-url', otpUrl);
    trigger.setAttribute('data-pkg-qty', String(p.bottles || 1));
    return bogoStore.open(BOGO.sectionId, trigger);
  }

  function checkout(profile, firstName, email) {
    var p = PACKAGES.filter(function (x) { return x.k === resPlan; })[0];
    var eventParams = {
      content_ids: [String(p.variantId)],
      content_name: profile.name,
      content_type: 'product',
      contents: [{ id: String(p.variantId), quantity: 1 }],
      currency: 'USD',
      value: p.total,
      num_items: p.bottles
    };
    track('AddToCart', eventParams);
    track('InitiateCheckout', eventParams);

    var discountCode = window.KERALUSH_V2_DISCOUNT || '';
    var discountParam = discountCode ? ('?discount=' + encodeURIComponent(discountCode)) : '';

    var quizProps = {
      'Quiz Profile': profile.name,
      'GLP-1 Medication': state.answers.glp1 || '',
      'GLP-1 Duration': state.answers.duration || '',
      'Shedding Level': state.answers.shedding != null ? String(state.answers.shedding) : '',
      'First Name': firstName || '',
      'Email': email || ''
    };
    var otpUrl = buildCheckoutPermalink(p, quizProps, null, discountParam);
    if (triggerBogoPopup(p, otpUrl)) return;
    if (triggerUpsellPopup(p, quizProps, otpUrl, discountParam)) return;

    window.location.href = otpUrl;
  }

  /* ---------- RESULTS render ---------- */
  function resultsHTML(profile, triggers) {
    var html = '<div class="results" data-screen-label="Results">';

    // HERO
    var bullets = '';
    if (profile.personalBullets.length > 0) {
      bullets += '<ul class="personal-bullets">';
      profile.personalBullets.forEach(function (b) {
        bullets += '<li><span class="pb-check">✓</span><span class="pb-text"><span class="pb-label">' + b.label + '</span>' +
          (b.tag ? '<span class="pb-tag"> · ' + b.tag + '</span>' : '') + '</span></li>';
      });
      bullets += '</ul>';
    }
    html += '<div class="results-hero" id="sec-top">' +
      '<div style="position:relative;z-index:2">' +
        '<div class="trigger-badge">Your trigger: <strong>' + profile.trigger + '</strong></div>' +
        '<h1 class="profile-name">' + profile.name + '</h1>' +
        '<p class="profile-sub">' + profile.subtitle + '</p>' +
        bullets +
        '<button class="pulse-arrow" aria-label="See your personal protocol"><span class="pa-label">See your personal protocol</span><span class="pa-chev">↓</span></button>' +
      '</div>' +
    '</div>';

    // WHY THIS IS HAPPENING
    var blurbHTML = '';
    profile.blurb.forEach(function (para) { blurbHTML += '<p>' + para + '</p>'; });
    blurbHTML += '<p class="start-now" data-scroll="offer-anchor" style="cursor:pointer"><strong>Start My 90-Day Hair Transformation Protocol</strong></p>';

    var dropHTML = '';
    if (profile.dropList.length > 0) {
      dropHTML += '<div class="drop-list"><div class="drop-list-eyebrow">Drop from your stack</div>' +
        '<p class="drop-list-intro">You told us you\'ve already tried these. Here\'s why they\'re not moving the needle on either GLP-1 pathway.</p>' +
        '<ul class="drop-list-items">';
      profile.dropList.forEach(function (item) {
        dropHTML += '<li class="drop-list-item"><span class="dl-x">✕</span><div class="dl-body"><div class="dl-name">' + item.label + '</div><div class="dl-why">' + item.why + '</div></div></li>';
      });
      dropHTML += '</ul></div>';
    }

    html += '<div class="section" id="sec-why" style="padding-top:18px">' +
      '<div class="section-eyebrow">Why this is happening to you</div>' +
      '<div class="profile-blurb">' + blurbHTML + '</div>' +
      dropHTML +
      '<p class="why-flow">All of this is hitting your follicles at the <em>same time</em>. Below... the <strong>2 GLP-1 pathways</strong> your protocol has to address, broken down by trigger.</p>' +
    '</div>';

    // TRIGGER BREAKDOWN
    html += '<div class="section" id="sec-triggers" style="padding-bottom:0">' +
      '<div class="section-eyebrow">Inside the pathways</div>' +
      '<h2>The triggers feeding <em>both GLP-1 pathways.</em></h2>' +
    '</div>' +
    '<div class="trigger-hint">Tap any card to see what it means</div>' +
    '<div class="trigger-grid">';
    triggers.forEach(function (t, i) {
      var scoreColor = t.score >= 70 ? 'var(--orange)' : t.score >= 50 ? 'var(--orange-soft)' : 'var(--ink-3)';
      var riskClass = t.score >= 75 ? 'risk-critical' : t.score >= 60 ? 'risk-high' : t.score >= 45 ? 'risk-mod' : 'risk-low';
      var riskLabel = t.score >= 75 ? 'CRITICAL' : t.score >= 60 ? 'HIGH' : t.score >= 45 ? 'MODERATE' : 'LOW';
      var barBg = t.score >= 70 ? 'var(--orange)' : 'var(--orange-soft)';
      html += '<button type="button" class="trigger-card flip" data-flip="' + i + '" aria-pressed="false" aria-label="' + attr(t.name + ': ' + Math.round(t.score) + ' percent... tap for details') + '">' +
        '<div class="flip-inner">' +
          '<div class="flip-face flip-front">' +
            '<div class="front-top">' +
              '<div class="score" style="color:' + scoreColor + '">' + Math.round(t.score) + '<span style="font-size:16px">%</span></div>' +
              '<div class="risk-pill ' + riskClass + '">' + riskLabel + '</div>' +
            '</div>' +
            '<div class="name">' + t.name + '</div>' +
            '<div class="tag">' + t.tag + '</div>' +
            '<div class="bar"><div class="bar-fill" style="width:' + t.score + '%;animation-delay:' + (i * 120) + 'ms;background:' + barBg + '"></div></div>' +
            '<div class="front-foot"><span class="stat-line">' + t.stat + '</span><span class="flip-cue">Tap →</span></div>' +
          '</div>' +
          '<div class="flip-face flip-back">' +
            '<div class="back-name">' + t.name + '</div>' +
            '<div class="back-what">' + t.what + '</div>' +
            '<div class="back-fix"><strong>Your protocol:</strong> ' + t.fix + '</div>' +
            '<div class="flip-cue back-cue">Tap to flip back</div>' +
          '</div>' +
        '</div>' +
      '</button>';
    });
    html += '</div>';

    // PROOF
    html += '<div class="trigger-proof">' +
      '<div class="trigger-proof-eyebrow">What reversal looks like</div>' +
      '<div class="trigger-proof-h">When both pathways get addressed at once... <em>this is what happens.</em></div>' +
      '<div class="trigger-proof-img">' + heroPic({ src: RIMG.intro_ba_hero, alt: 'Dana R. before and after... hair restored after 18 weeks' }) +
        '<span class="corner-tag corner-tag-l">WEEK 1</span><span class="corner-tag corner-tag-r">WEEK 18</span>' +
      '</div>' +
      '<div class="trigger-proof-cap">DANA R. · 9 MONTHS ON WEGOVY · DOWN 52 LBS</div>' +
    '</div>';

    html += '<div class="section-jump"><button data-scroll="sec-failures">See why nothing has worked yet ↓</button></div>';

    // WHY NOTHING HAS WORKED
    html += '<div class="section" id="sec-failures">' +
      '<div class="section-eyebrow">Why nothing has worked</div>' +
      '<h2>You\'ve tried things. <em>Here\'s why they failed.</em></h2>' +
      '<p class="section-intro">Single-ingredient supplements target one trigger. Your hair loss has 2 active GLP-1 pathways. The math has never been on your side.</p>' +
      '<div class="failures">';
    RESULTS_FAILURES.forEach(function (f) {
      html += '<div class="failure-row">' + heroPic({ src: RIMG.x_mark, alt: '', className: 'failure-x' }) +
        '<div class="failure-body"><div class="failure-name">' + f.n + '</div><div class="failure-why">' + f.w + '</div></div></div>';
    });
    html += '</div></div>';

    // MEET KERALUSH
    html += '<div class="section" id="sec-meet" style="background:var(--cream)">' +
      '<div class="meet-hero">' +
        '<div class="section-eyebrow">Introducing</div>' +
        '<h2 class="meet-h">Rejuveen <em>KeraLush</em>... built for women on the shot.</h2>' +
        '<div class="meet-bottle-wrap">' + heroPic({ src: RIMG.bottle, alt: 'Rejuveen KeraLush bottle', className: 'meet-bottle-hero', sizes: '320px' }) + '</div>' +
        '<p class="section-intro meet-intro">The first multi-pathway formula designed specifically for GLP-1-driven hair loss. 5 clinical ingredients. Both GLP-1 hair-loss pathways. One capsule, twice a day.</p>' +
      '</div>' +
      '<div class="meet-benefits">' +
        '<div class="benefit-row"><div class="benefit-num">01</div><div class="benefit-body"><div class="benefit-name">Lowers cortisol at the root</div><div class="benefit-why">Shoden® ashwagandha drops cortisol 66% in 60 days... your follicles wake back up.</div></div></div>' +
        '<div class="benefit-row"><div class="benefit-num">02</div><div class="benefit-body"><div class="benefit-name">Rebuilds the anchor</div><div class="benefit-why">keraGEN-IV® delivers keratin and Type IV collagen so strands stay locked in.</div></div></div>' +
        '<div class="benefit-row"><div class="benefit-num">03</div><div class="benefit-body"><div class="benefit-name">Neutralizes the toxin dump</div><div class="benefit-why">zeropollution® clears 80% of scalp oxidative particles released during fat loss.</div></div></div>' +
        '<div class="benefit-row"><div class="benefit-num">04</div><div class="benefit-body"><div class="benefit-name">Refills the depleted nutrients</div><div class="benefit-why">Clinical doses of biotin, zinc, copper, and vitamins C + E... not sprinkle amounts.</div></div></div>' +
        '<div class="benefit-row"><div class="benefit-num">05</div><div class="benefit-body"><div class="benefit-name">Works with your shot, not against it</div><div class="benefit-why">Formulated for GLP-1 metabolism. Keep the weight loss. Keep the hair.</div></div></div>' +
      '</div>' +
      '<div class="expert-quote">' +
        '<div class="expert-stars">★★★★★</div>' +
        '<div class="expert-body">' + heroPic({ src: RIMG.megan, alt: 'Megan D\'Andrea, RN', className: 'expert-img', fallback: 'jpg' }) +
          '<div class="expert-text">' +
            '<p>"A science-backed supplement that supports hair strength, shine, and growth. With biotin, keratin, and collagen, my hair feels stronger and more resilient even after ER shifts."</p>' +
            '<div class="expert-name">Megan D\'Andrea</div>' +
            '<div class="expert-title">RN, BSN, PCCN</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    // REAL-RESULTS GALLERY
    html += '<div class="section" id="sec-gallery">' +
      '<div class="section-eyebrow">Real women · real results</div>' +
      '<h2>Women with your <em>exact profile</em> saw this.</h2>' +
      '<div class="ba-grid">' +
        '<div class="ba-tile"><img src="' + attr(RIMG.ba_1) + '" alt="Regrowth"><div class="ba-cap">Temples restored</div></div>' +
        '<div class="ba-tile"><img src="' + attr(RIMG.ba_4) + '" alt="Regrowth"><div class="ba-cap">Less shedding</div></div>' +
        '<div class="ba-tile"><img src="' + attr(RIMG.ba_2) + '" alt="Regrowth"><div class="ba-cap">Shinier strands</div></div>' +
        '<div class="ba-tile"><img src="' + attr(RIMG.ba_3) + '" alt="Regrowth"><div class="ba-cap">New growth</div></div>' +
      '</div>' +
    '</div>';

    // TESTIMONIAL HERO
    html += '<div class="testimonial">' +
      '<span class="quote-mark">"</span>' +
      '<div class="q">I stayed on my shot because it changed my life. But KeraLush gave me my hair back. That\'s when I knew this was different.</div>' +
      '<div class="who"><img src="' + attr(RIMG.port_1) + '" alt="Rachel" class="avatar-img">' +
        '<div class="who-meta"><div class="name">Rachel · 43</div><div class="detail">Down 52 lbs · Same profile as you</div></div>' +
      '</div>' +
    '</div>';

    // TIMELINE
    html += '<div class="section" id="sec-timeline">' +
      '<div class="section-eyebrow">What to expect</div>' +
      '<h2>Here\'s what happens <em>on KeraLush.</em></h2>' +
      '<div class="timeline">';
    RESULTS_TIMELINE.forEach(function (t) {
      html += '<div class="timeline-item"><div class="week">' + t.week + '</div><div class="phase">' + t.phase + '</div><div class="detail">' + t.detail + '</div></div>';
    });
    html += '</div>' +
      '<div class="section-jump" style="margin-top:20px"><button data-scroll="sec-ingredients">See the ingredients ↓</button></div>' +
    '</div>';

    // INGREDIENTS
    html += '<div class="section" id="sec-ingredients" style="background:#fff;border-top:1px solid var(--line);border-bottom:1px solid var(--line)">' +
      '<div class="section-eyebrow">Your personalized 90-day protocol</div>' +
      '<h2>The ingredients <em>built for you.</em></h2>' +
      '<div style="margin-top:8px">';
    RESULTS_INGREDIENTS.forEach(function (i) {
      var isPrimary = profile.primaryIngredients.indexOf(i.match) !== -1;
      var benefits = '';
      i.benefits.forEach(function (b) { benefits += '<li>' + b + '</li>'; });
      html += '<div class="ingredient-tile' + (isPrimary ? ' is-primary' : '') + '">' +
        '<div class="ig-img-real">' + heroPic({ src: i.img, alt: i.name, sizes: '84px' }) + '</div>' +
        '<div>' +
          '<div class="ig-name">' + i.name + ' ' + (isPrimary ? '<span class="ig-pill">For you</span>' : '') + '</div>' +
          '<div class="ig-dose">' + i.dose + '</div>' +
          '<div class="ig-claim">' + i.claim + '</div>' +
          (isPrimary ? '<div class="ig-why">' + i.why + '</div>' : '') +
          '<ul class="ig-benefits">' + benefits + '</ul>' +
        '</div>' +
      '</div>';
    });
    html += '</div></div>';

    // TESTIMONIAL GRID
    html += '<div class="section">' +
      '<div class="section-eyebrow">Trusted by 3M+ women</div>' +
      '<h2>Reviews from women on <em>the shot.</em></h2>' +
      '<div class="review-grid">';
    RESULTS_TESTIMONIALS.forEach(function (t) {
      html += '<div class="review-card"><img src="' + attr(t.img) + '" alt="' + attr(t.name) + '">' +
        '<div class="review-body"><div class="stars">★★★★★</div><h4 class="review-headline">' + t.headline + '</h4>' +
        '<p>"' + t.quote + '"</p>' +
        '<div class="who-meta"><div class="name">' + t.name + '</div><div class="detail">' + t.detail + '</div></div></div></div>';
    });
    html += '</div></div>';

    // CROSSROADS
    html += '<div class="section" id="sec-crossroads">' +
      '<div class="section-eyebrow">Your crossroads</div>' +
      '<h2>What are your <em>other options</em>... really?</h2>' +
      '<p class="section-intro">Two paths from here. One you already know. One that finally treats the cause.</p>' +
      '<div class="crossroads">' +
        '<div class="path path-a">' +
          '<div class="path-tag">PATH A</div><div class="path-title">Wait it out</div>' +
          '<ul class="path-list">' +
            '<li><span class="dot dot-bad"></span>Shedding gets worse before it gets better</li>' +
            '<li><span class="dot dot-bad"></span>6+ months of watching the part widen</li>' +
            '<li><span class="dot dot-bad"></span>Single-ingredient supplements keep failing</li>' +
            '<li><span class="dot dot-bad"></span>Quietly consider stopping the shot</li>' +
            '<li><span class="dot dot-bad"></span>Lose the metabolic progress too</li>' +
          '</ul>' +
          '<div class="path-foot path-foot-a">Same outcome. Just slower.</div>' +
        '</div>' +
        '<div class="path-or"><span>OR</span></div>' +
        '<div class="path path-b">' +
          '<div class="path-tag path-tag-b">PATH B</div><div class="path-title">Start your protocol</div>' +
          '<ul class="path-list">' +
            '<li><span class="dot dot-good"></span>Less shedding inside 30 days</li>' +
            '<li><span class="dot dot-good"></span>Anchor proteins rebuilt at the root</li>' +
            '<li><span class="dot dot-good"></span>Cortisol down 66% in 60 days</li>' +
            '<li><span class="dot dot-good"></span>Visible regrowth by month 3</li>' +
            '<li><span class="dot dot-good"></span>Keep the shot. Keep the hair.</li>' +
          '</ul>' +
          '<div class="path-foot path-foot-b">Backed by 90-day guarantee.</div>' +
        '</div>' +
      '</div>' +
    '</div>';

    // OFFER FLOW
    html += '<div class="pre-offer-cta">' +
      '<div class="poc-ey">Ready to start?</div>' +
      '<div class="poc-t">Your personalized 90-day protocol is waiting.</div>' +
      '<button class="btn-primary" data-scroll="offer-anchor">Claim my protocol <span class="arrow">→</span></button>' +
    '</div>' +
    '<div id="offer-anchor" class="offer-wrap">' + offerWrapInnerHTML() + '</div>';

    // TRUST
    html += '<div class="trust-section"><div class="trust-card"><img src="' + attr(RIMG.money_back) + '" alt="90-day guarantee">' +
      '<div><div class="trust-t">90-Day Money-Back Guarantee</div><div class="trust-d">If you don\'t see less shedding and more density, we\'ll refund every penny... even the empty bottles.</div></div></div></div>';

    // ORDER SUMMARY
    html += '<div class="order-summary">' +
      '<div class="os-eyebrow">Here\'s what\'s waiting</div>' +
      '<h3 class="os-title">Your <em>' + profile.name + '</em> protocol</h3>' +
      '<div class="os-card">' +
        '<div class="os-card-head">' + heroPic({ src: RIMG.bottle, alt: 'KeraLush bottle', className: 'os-bottle', sizes: '(min-width: 768px) 240px, 200px' }) +
          '<div class="os-head-txt"><div class="os-product">Rejuveen KeraLush</div><div class="os-tagline">90-day starter protocol · 60 capsules</div></div>' +
        '</div>' +
        '<ul class="os-benefits">' +
          '<li><span class="os-tick">✓</span><span><strong>Addresses both GLP-1 hair-loss pathways at the source.</strong> Metabolic Follicle Disruption and Growth Signal Suppression, in one capsule.</span></li>' +
          '<li><span class="os-tick">✓</span><span><strong>A cleaner pillow inside 30 days.</strong> Less in the shower drain. Less wrapped around the brush.</span></li>' +
          '<li><span class="os-tick">✓</span><span><strong>Cuts hair fall nearly in half by month 2.</strong> Clinical trial, 60 days, keraGEN-iV™... not another gummy promise.</span></li>' +
          '<li><span class="os-tick">✓</span><span><strong>Calms the cortisol driving the shed.</strong> Real sleep again. Less lying awake at 3am doing the math on your hairline.</span></li>' +
          '<li><span class="os-tick">✓</span><span><strong>By month 3, your hair growth cycle has had a full reset window.</strong> Powered by clinical doses of keratin, biotin, zinc, and copper.</span></li>' +
          '<li><span class="os-tick">✓</span><span><strong>Keep every pound you\'ve earned.</strong> Zero known interactions with your shot. You don\'t have to choose between your body and your hair.</span></li>' +
        '</ul>' +
        '<div class="os-reminders">' +
          '<div class="os-reminder"><span class="os-rem-ico">⛨</span><div><strong>90-day money-back guarantee.</strong> Even the empty bottles.</div></div>' +
          '<div class="os-reminder"><span class="os-rem-ico">↺</span><div><strong>Cancel or pause anytime.</strong> No phone calls, no friction.</div></div>' +
          '<div class="os-reminder"><span class="os-rem-ico">▦</span><div><strong>Free US shipping</strong> on 2+ bottles.</div></div>' +
        '</div>' +
        '<button class="btn-primary os-cta" data-scroll="offer-anchor">Start my 90-day protocol <span class="arrow">→</span></button>' +
        '<div class="os-fine">No email required to see your results · Reviewed by endocrine RNs</div>' +
      '</div>' +
    '</div>';

    html += '<div class="trust-row"><span>As seen in</span><span>VOGUE</span><span>·</span><span>FORBES</span><span>·</span><span>WOMEN\'S HEALTH</span></div>';

    // FAQ
    html += '<section class="faq" id="sec-faq"><div class="faq-eyebrow">FAQ</div><h3 class="faq-title">Frequently asked questions</h3><div class="faq-list">';
    RESULTS_FAQ.forEach(function (item) {
      html += '<details name="faq" class="faq-item"><summary class="faq-q"><span class="faq-q-text">' + item.q + '</span><span class="faq-icon" aria-hidden="true"></span></summary><div class="faq-a">' + item.a + '</div></details>';
    });
    html += '</div></section>';

    // FINAL CTA
    html += '<div class="final-cta">' +
      '<div class="final-cta-eyebrow">Ready when you are</div>' +
      '<h3>Stop the shedding. <em>Keep the shot.</em></h3>' +
      '<p>Your "' + profile.name + '" protocol is waiting. Most women see less shedding inside 30 days.</p>' +
      '<button class="btn-primary final-cta-btn" data-scroll="offer-anchor">Start my protocol →</button>' +
      '<div class="final-cta-foot">90-day money-back guarantee · Free shipping</div>' +
    '</div>';

    html += '<div class="fine">*Results vary. Statistics from published peer-reviewed clinical studies on keraGEN-IV®, Shoden®, and zeropollution®. These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease.</div>';

    html += '<div style="padding:0 24px 40px;text-align:center"><button class="btn-primary btn-ghost" data-action="restart">Retake the quiz</button></div>';

    html += '</div>'; // .results
    return html;
  }

  function wireResults(rootEl, profile) {
    // scroll links
    var lastScrollTap = 0;
    function handleScrollActivation(btn, e) {
      var now = Date.now();
      if (e.type === 'click' && now - lastScrollTap < 700) return;
      if (e.type === 'touchend') lastScrollTap = now;
      e.preventDefault();
      e.stopPropagation();
      scrollToId(btn.getAttribute('data-scroll'));
    }
    rootEl.querySelectorAll('[data-scroll]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { handleScrollActivation(btn, e); });
      btn.addEventListener('touchend', function (e) { handleScrollActivation(btn, e); }, { passive: false });
    });
    // restart
    var restartBtn = rootEl.querySelector('[data-action="restart"]');
    if (restartBtn) restartBtn.addEventListener('click', restart);

    // trigger flip cards
    rootEl.querySelectorAll('[data-flip]').forEach(function (card) {
      card.addEventListener('click', function () {
        var isFlipped = card.classList.contains('is-flipped');
        rootEl.querySelectorAll('[data-flip].is-flipped').forEach(function (c) {
          c.classList.remove('is-flipped'); c.setAttribute('aria-pressed', 'false');
        });
        if (!isFlipped) { card.classList.add('is-flipped'); card.setAttribute('aria-pressed', 'true'); }
      });
    });

    // FAQ accordion (single-open)
    rootEl.querySelectorAll('details.faq-item').forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) {
          var list = d.parentNode;
          list.querySelectorAll('details.faq-item[open]').forEach(function (other) {
            if (other !== d) other.removeAttribute('open');
          });
        }
      });
    });

    // offer
    var wrap = rootEl.querySelector('#offer-anchor');
    if (wrap) wireOffer(wrap, profile);
  }

  /* ============== MAIN RENDER ============== */
  function renderApp() {
    runCleanup();
    var cur = STEPS[state.step];
    var qs = QUIZ_DATA.questions;
    var edu = QUIZ_DATA.education;
    var totalQuestions = qs.length;
    var questionsSeenBeforeHere = STEPS.slice(0, state.step).filter(function (s) { return s.type === 'q'; }).length;

    var viewHTML = '';
    var type = cur.type;
    var profile = null, triggers = null;

    if (type === 'intro') {
      viewHTML = introHTML();
    } else if (type === 'q') {
      viewHTML = questionHTML(qs[cur.idx], cur.idx, totalQuestions);
    } else if (type === 'edu1') {
      viewHTML = eduStatHTML(edu.stat1, questionsSeenBeforeHere - 1, totalQuestions);
    } else if (type === 'edu2') {
      viewHTML = eduTriggersHTML(edu.stat2, questionsSeenBeforeHere - 1, totalQuestions);
    } else if (type === 'edu3') {
      viewHTML = eduStatHTML(edu.stat3, questionsSeenBeforeHere - 1, totalQuestions);
    } else if (type === 'analyze') {
      viewHTML = analyzingHTML();
    } else if (type === 'results') {
      resPlan = '90'; resOfferStep = 1;
      profile = computeProfile(state.answers);
      triggers = computeTriggers(state.answers);
      viewHTML = resultsHTML(profile, triggers);
    }

    var isResults = type === 'results';
    var root = document.getElementById('keralush-quiz-root');
    var _logoSrc = (window.KERALUSH_V2_IMGS && window.KERALUSH_V2_IMGS.logo) || 'quiz/img/rejuveen-logo.png';
    root.innerHTML = '<div class="phone-frame' + (isResults ? ' scroll' : '') + '">' +
      '<div class="brand-ribbon"><img src="' + _logoSrc + '" alt="Rejuveen"></div>' +
      viewHTML +
    '</div>';
    var frame = root.firstElementChild;

    if (type === 'intro') wireIntro(frame);
    else if (type === 'q') wireQuestion(frame, qs[cur.idx], cur.idx, totalQuestions);
    else if (type === 'edu1') wireEduStat(frame, edu.stat1);
    else if (type === 'edu2') wireEduTriggers(frame, edu.stat2);
    else if (type === 'edu3') wireEduStat(frame, edu.stat3);
    else if (type === 'analyze') wireAnalyzing(frame);
    else if (type === 'results') {
      wireResults(frame, profile);
      track('QuizComplete', {
        content_name: profile.name,
        glp1_medication: state.answers.glp1,
        glp1_duration: state.answers.duration,
        shedding_level: state.answers.shedding
      });
    }
  }

  /* ============== BOOT ============== */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderApp);
  } else {
    renderApp();
  }
})();
